import React, { useEffect, useMemo, useState } from "react";
import { useTheme } from "../../../Themecontext/Themecontext";
import { useSelector } from "react-redux";
import { Row, Col, Modal, Button } from "react-bootstrap";
import Millstagetablecruad from "../../../components/Tables/Millstagetablecruad";
import { toast } from "react-toastify";
import {
    Plus,
    ArrowLeft,
    ArrowRight,
    Save,
    X,
    Info,
    Layers
} from "lucide-react";

import AccessGate from "./components/AccessGate";
import MasterForm from "./components/MasterForm";
import AvailableLotsPanel from "./components/AvailableLotsPanel";
import AllocatedLotsPanel from "./components/AllocatedLotsPanel";
import AllocationModal from "./components/AllocationModal";
import StoppageModal from "./components/StoppageModal";
import RecipeModal from "./components/RecipeModal";
import TakaDetailModal from "./components/TakaDetailModal";
import HelpModal from "./components/HelpModal";
import { useDispatch } from "react-redux";
import { AllFilter, AppSetupDetail, clearTransFilters, GetStageSrNo, LotPendHelp, TransDelete, TransFilters, TransShowAll, TransShowOne, TransSubDtlInsertHelp, GetAvgRate, TransInsert, TransUpdate, TransDeleteCheck } from "../../../Redux/Slice/MillstageEntry/MillstageEntrySlice";
import Cookies from "js-cookie";
import { Filter } from "../../../Redux/Slice/login/loginSlice";

// Mock Data for Available Lots
const INITIAL_AVAILABLE = [
    { id: "L1", lotNo: "LOT-2045-A", inwDate: "2026-08-01", inwSrNo: "SR-0101", acName: "Nandan Denim Ltd", pty: "P001", groupName: "Denim-Grey", quality: "14oz Indigo Denim", taka: 45, meter: 4500 },
    { id: "L2", lotNo: "LOT-2045-B", inwDate: "2026-08-02", inwSrNo: "SR-0102", acName: "Vardhman Textiles", pty: "P002", groupName: "Cotton-Grey", quality: "50s combed cotton", taka: 32, meter: 3200 },
    { id: "L3", lotNo: "LOT-2045-C", inwDate: "2026-08-02", inwSrNo: "SR-0103", acName: "Raymond Premium", pty: "P003", groupName: "Woolen-Grey", quality: "Super 140s Merino Wool", taka: 15, meter: 1500 },
    { id: "L4", lotNo: "LOT-2045-D", inwDate: "2026-08-03", inwSrNo: "SR-0104", acName: "Arvind Limited", pty: "P004", groupName: "Linen-Grey", quality: "60 Lea Pure Linen", taka: 20, meter: 2200 },
    { id: "L5", lotNo: "LOT-2045-E", inwDate: "2026-08-04", inwSrNo: "SR-0105", acName: "Welspun Terry", pty: "P005", groupName: "Terry-Grey", quality: "500 GSM Zero Twist Terry", taka: 25, meter: 2500 }
];

// Stoppage reasons list options
const STOPPAGE_REASONS = [
    { id: "MECH", label: "Mechanical Breakdown", value: "Mechanical Breakdown" },
    { id: "ELEC", label: "Electrical Power Fault", value: "Electrical Power Fault" },
    { id: "PROC", label: "Process / Recipe Issue", value: "Process / Recipe Issue" },
    { id: "STEAM", label: "Steam Supply Shortage", value: "Steam Supply Shortage" },
    { id: "WATER", label: "Water Supply Delay", value: "Water Supply Delay" },
    { id: "MNT", label: "Scheduled Maintenance", value: "Scheduled Maintenance" },
    { id: "CLN", label: "Machine Cleaning", value: "Machine Cleaning" },
    { id: "LABOR", label: "Operator Shift Delay", value: "Operator Shift Delay" }
];


const SHIFTS_LIST = [
    { label: "Shift A (08:00 - 16:00)", value: "ShiftA" },
    { label: "Shift B (16:00 - 00:00)", value: "ShiftB" },
    { label: "Shift C (00:00 - 08:00)", value: "ShiftC" }
];

const TREATMENT_LIST = [
    { label: "Wash Treatment", value: "Wash" },
    { label: "Dyeing Treatment", value: "Dye" },
    { label: "Bleach Treatment", value: "Bleach" },
    { label: "Mercerize Treatment", value: "Merc" },
    { label: "Finish Treatment", value: "Finish" }
];



const INITIAL_RECORDS = [
    {
        id: "TXN1001",
        txnDate: "2026-08-12",
        srNo: "SRN-8902",
        fromStage: "SINGING",
        toMachine: "MC02",
        fromSubStage: "PrepA",
        process: "BleachDesize",
        remark: "First shift batch priority allocation",
        params: {
            shift: "ShiftA",
            inTime: "2026-08-12T08:15",
            outTime: "2026-08-12T12:30",
            weight: "1200",
            chartNo: "CH-D22",
            avgWeight: "60"
        },
        selectedLots: [
            {
                id: "L1",
                lotNo: "LOT-2045-A",
                inwDate: "2026-08-01",
                inwSrNo: "SR-0101",
                acName: "Nandan Denim Ltd",
                pty: "P001",
                groupName: "Denim-Grey",
                quality: "14oz Indigo Denim",
                issueTaka: 20,
                issueMeter: 2000
            }
        ]
    }
];

const LotEntry = () => {

    const FinancialYear = Cookies.get("FinancialYear");
    const userId = Cookies.get("SqlId");
    const FirmID = Cookies.get("Firm");

    // Theme & Redux Colors
    const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);

    const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWMILLSTAGE");
    const iscolourDark = Colourdata?.data?.find((el) => el.ExeName === "NEWMILLSTAGEDARK");
    const { theme } = useTheme();
    const isdark = theme;
    const dispatch = useDispatch();

    // Verification Gate States
    const [isGatePassed, setIsGatePassed] = useState(false);
    const [gateStageVal, setGateStageVal] = useState("");
    const [gateStageId, setGateStageId] = useState(null);
    const [gateTxnVal, setGateTxnVal] = useState("");
    const [gateTxnId, setGateTxnId] = useState(null);

    const [isGateLoading, setIsGateLoading] = useState(false);

    // Form & Action states
    const [isAdding, setIsAdding] = useState(false);
    const [editingId, setEditingId] = useState(null);

    const [recipeDetails, setRecipeDetails] = useState([]);
    const [treatmentDetails, setTreatmentDetails] = useState([]);

    // Recipe Detail API responses
    const [recipeItemApiData, setRecipeItemApiData] = useState([]);

    const [Details, setDetails] = useState([]);
    const [SubMianDetails, setSubMianDetails] = useState([]);
    const [mappedDetails, setMappedDetails] = useState([]);

    console.log("hello : ", SubMianDetails);


    // Masters inputs
    const [txnDate, setTxnDate] = useState(new Date().toISOString().split("T")[0]);

    console.log(txnDate);


    const [srNo, setSrNo] = useState("");

    const [fromStageVal, setFromStageVal] = useState("");
    const [fromStageId, setFromStageId] = useState(null);

    console.log(fromStageVal);
    console.log(fromStageId);


    const [toMachineVal, setToMachineVal] = useState("");
    const [toMachineId, setToMachineId] = useState(null);

    const [fromSubStageVal, setFromSubStageVal] = useState("");
    const [fromSubStageId, setFromSubStageId] = useState(null);

    console.log(fromSubStageVal);
    console.log(fromSubStageId);


    const [filteredSubStageList, setFilteredSubStageList] = useState([]);

    const [processVal, setProcessVal] = useState("");
    const [processId, setProcessId] = useState(null);

    const [processQualityVal, setProcessQualityVal] = useState("");
    const [processQualityId, setProcessQualityId] = useState(null);

    console.log(processQualityVal);
    console.log(processQualityId);


    const [transactionMasterVal, setTransactionMasterVal] = useState("");
    const [transactionMasterId, setTransactionMasterId] = useState(null);

    const [remark, setRemark] = useState("");

    // Redesign form inputs

    const [treatmentVal, setTreatmentVal] = useState("");
    const [treatmentId, setTreatmentId] = useState(null);

    const [recipeVal, setRecipeVal] = useState("");
    const [recipeId, setRecipeId] = useState(null);

    console.log(recipeVal);

    const [processTypeVal, setProcessTypeVal] = useState("");
    const [processTypeId, setProcessTypeId] = useState(null);

    const [machineVal, setMachineVal] = useState("");
    const [machineId, setMachineId] = useState(null);

    const [shadeVal, setShadeVal] = useState("");
    const [shadeId, setShadeId] = useState(null);

    const ProcessMstID = Cookies.get("millmaster");

    // Helper to get local ISO string formatted for datetime-local

    const getCurrentDateTimeLocal = () => {
        const now = new Date();

        const pad = (num) =>
            String(num).padStart(2, "0");

        return `${now.getFullYear()}-${pad(
            now.getMonth() + 1
        )}-${pad(
            now.getDate()
        )}T${pad(
            now.getHours()
        )}:${pad(
            now.getMinutes()
        )}`;
    };

    // ==========================================
    // Operational Parameter States
    // ==========================================


    const [operatorVal, setOperatorVal] = useState("");
    const [operatorId, setOperatorId] = useState(null);

    const [liquorVal, setLiquorVal] = useState("");
    const [liquorId, setLiquorId] = useState(null);

    const [batchNo, setBatchNo] = useState("");

    const [millVal, setMillVal] = useState("");

    const [progVal, setProgVal] = useState("");

    const [progDateVal, setProgDateVal] = useState(
        getCurrentDateTimeLocal()
    );

    const [shiftVal, setShiftVal] = useState("");

    const [inTime, setInTime] = useState(
        getCurrentDateTimeLocal()
    );

    const [outTime, setOutTime] = useState(
        getCurrentDateTimeLocal()
    );

    const [weight, setWeight] = useState("");
    const [ParamId, setParamId] = useState("");

    const [avgWeight, setAvgWeight] = useState("");

    const [chartNo, setChartNo] = useState("");

    const [costShPercent, setCostShPercent] = useState("");

    // Stoppage details modal states
    const [isStoppageModalOpen, setIsStoppageModalOpen] = useState(false);
    const [stoppageEntries, setStoppageEntries] = useState([
        { id: "S1", startTime: "2026-08-12T00:00", endTime: "", diff: "", reason: "" }
    ]);
    const [selectedStoppageRows, setSelectedStoppageRows] = useState({});

    // Grid Workspaces states
    const [records, setRecords] = useState(INITIAL_RECORDS);
    const [available, setAvailable] = useState(INITIAL_AVAILABLE);
    const [selected, setSelected] = useState([]);

    console.log(selected);






    // Checkboxes trackers
    const [checkedAvailable, setCheckedAvailable] = useState({});
    const [checkedSelected, setCheckedSelected] = useState({});

    //Available Roll Loat
    const [selectedAvailableLot, setSelectedAvailableLot] = useState(null);

    // Multiple selected Available Lot IDs ko sequentially process karne ke liye
    const [takaDetailQueue, setTakaDetailQueue] = useState([]);
    const [takaDetailIndex, setTakaDetailIndex] = useState(0);

    const [originalAvailableLots, setOriginalAvailableLots] = useState([]);
    const [editingAllocatedLot, setEditingAllocatedLot] = useState(null);
    const [AppSetupDetaildata, setAppSetupDetaildata] = useState(null);

    const [selectedRecipeRows, setSelectedRecipeRows] = useState([]);

    // Search filter terms
    const [searchAvailable, setSearchAvailable] = useState("");
    const [searchSelected, setSearchSelected] = useState("");
    const searchRecords = "";

    const [isRecipeModalOpen, setIsRecipeModalOpen] = useState(false);
    const [isTakaDetailOpen, setIsTakaDetailOpen] = useState(false);
    const [takaSearch, setTakaSearch] = useState("");
    const [selectedTakas, setSelectedTakas] = useState({});
    const [takaQty, setTakaQty] = useState("");
    const [initialIssueMeterValues, setInitialIssueMeterValues] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const [editedSubDetailsByLot, setEditedSubDetailsByLot] = useState({});

    console.log("selectedTakas", selectedTakas);
    console.log("initialIssueMeterValues", initialIssueMeterValues);


    // Modals toggles


    const [isAllocationModalOpen, setIsAllocationModalOpen] = useState(false);
    const [ISHelpModal, setISHelpModal] = useState([]);
    const [isHelpModalOpen, setIsHelpModalOpen] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [rowToDeleteId, setRowToDeleteId] = useState(null);

    // Temporary container for editing quantities during Move-Right validation  
    const [lotsToAllocate, setLotsToAllocate] = useState([]);
    const [allocationErrors, setAllocationErrors] = useState({});

    const [allFilterFields, setAllFilterFields] = useState([]);
    const [visibleFields, setVisibleFields] = useState([]);

    const [isRecipeDetailLoaded, setIsRecipeDetailLoaded] = useState(false);
    const [isIssueMeterEditable, setIsIssueMeterEditable] = useState(false);

    const [transactionData, setTransactionData] = useState({
        Main: [],
        Detail: [],
        SubDetail: [],
        RecipeDetail: [],
        ExFieldsValue: [],
    });

    const [isLotHelpOpen, setIsLotHelpOpen] = useState(false);

    // General Validation Errors
    const [errors, setErrors] = useState({});

    //My Code 
    useEffect(() => {
        dispatch(AllFilter());
    }, [dispatch]);

    const { AllFilterdata, TransShowAlldata, TransShowOnedata, TransFiltersdata, LotPendHelpdata, GetStageSrNodata, AppSetupDetaildata1, TransDeleteCheckdata } = useSelector((state) => state.MillstageEntry || {});




    const SubStageList =

        TransFiltersdata?.FromSubStage?.map(item => ({
            label: item?.SubStageName,
            value: item?.SubStageID,
            StageID: item?.StageID
        }))

        || [];

    const StageList1 = TransFiltersdata?.FromStage?.map(item => ({ label: item?.StageName, value: item?.StageID })) || [];
    const StageList = AllFilterdata?.Stage?.map(item => ({ label: item?.StageName, value: item?.StageID })) || [];
    const ToStageList = TransFiltersdata?.ToStage?.map(item => ({ label: item?.SubStageName, value: item?.SubStageID })) || [];
    const ProcessMstList = TransFiltersdata?.ProcessMst?.map(item => ({ label: item?.ProcessMstName, value: item?.ProcessMstId })) || [];
    const TransactionMasterList = TransFiltersdata?.ProcessMst?.map(item => ({
        label: item?.ProcessMstName,
        value: item?.ProcessMstId,
        ProcessMstID: item?.ProcessMstId,
    })) || [];

    const ProcessTypeList = TransFiltersdata?.ProcessType?.map(item => ({ label: item?.ProcessType, value: item?.ProcessTypeID })) || [];
    const MatchingList = TransFiltersdata?.Machine?.map(item => ({ label: item?.MachineName, value: item?.MachineId })) || [];
    const TreatmentList = TransFiltersdata?.Treatment?.map(item => ({ label: item?.Treatment, value: item?.TreatmentMstID })) || [];

    const ShadeList = TransFiltersdata?.Shade?.map(item => ({
        label: item?.MName,
        value: item?.MatchingID,
    })) || [];

    const RecipeList = TransFiltersdata?.Recipe?.map(item => ({
        label: item?.RecipeCode,
        value: item?.ProdConsRecipeMstID,

        MatchingId: item?.MatchingId ?? item?.MatchingID ?? null,
        QualityId: item?.QualityId ?? item?.QualityID ?? null,
    })) || [];

    const selectedRecipe = (recipeDetails || []).find(
        row =>
            String(row?.RecipeMstID ?? row?.RecipeID) ===
            String(recipeId)
    );

    const recipeMachineId =
        selectedRecipe?.MachineId ??
        selectedRecipe?.MachineID ??
        "";

    const ProcessQualityType = TransFiltersdata?.ProcQuality?.map(item => ({
        label: item?.ProcessQualityName,
        value: item?.ProcessQualityId,
    })) || [];

    const GroupList = AllFilterdata?.Party?.map(item => ({ label: item?.GroupName, value: item?.GroupID })) || [];
    const QualityType = AllFilterdata?.Quality?.map(item => ({ label: item?.QualityType, value: item?.QualityID })) || [];
    const QualityType2 = AllFilterdata?.QualityType?.map(item => ({ label: item?.QualityType, value: item?.QualityID })) || [];
    const ItemList = AllFilterdata?.Item?.map(item => ({ label: item?.ItemName, value: item?.ItemId, value1: item?._I_CODE })) || [];
    const ItemSubGroupList = AllFilterdata?.Item?.map(item => ({ label: item?.ItemProcessGroupName, value: item?.ItemProcessGroupId })) || [];
    const ItemName = AllFilterdata?.Item?.map(item => ({
        ...item,
        label: item?.ItemName,
        value: item?.ItemId,
        value1: item?._I_CODE
    })) || [];
    const ProcessGrpList = AllFilterdata?.ProcessGrp?.map(item => ({ label: item?.ItemProcessGroupName, value: item?.ItemProcessGroupID })) || [];
    const PartyList = AllFilterdata?.Party?.map(item => ({ label: item?.AcName, value: item?.AcID })) || [];

    const TransTypeList = useMemo(() => {
        return (
            AllFilterdata?.TransType?.map(item => ({
                label: item?.TTName,
                value: item?.TransTypeID,
                ToStageID: item?.ToStageID,
                TransTypeID: item?.TransTypeID
            })) || []
        );
    }, [AllFilterdata?.TransType]);

    useEffect(() => {
        if (!gateStageId) {
            setGateTxnVal("");
            setGateTxnId(null);
            return;
        }

        const filtered = TransTypeList.filter(
            item => Number(item.ToStageID) === Number(gateStageId)
        );

        if (filtered.length > 0) {
            setGateTxnVal(filtered[0].label);
            setGateTxnId(filtered[0].value);
        } else {
            setGateTxnVal("");
            setGateTxnId(null);
        }
    }, [gateStageId, TransTypeList]);



    const handleProcessFilter = async ({
        ProcessMstID = 0,
        ProcessTypeID = 0
    } = {}) => {
        try {
            const FirmID = Cookies.get("Firm");

            const payload = {
                FirmID: String(FirmID || ""),
                TransTypeID: String(gateTxnId || ""),
                ProcessMstID: ProcessMstID || 0,
                ProcessTypeID: ProcessTypeID || 0,
            };

            console.log("TransFilters Payload:", payload);

            const response = await dispatch(
                TransFilters(payload)
            ).unwrap();

            console.log("TransFilters Response:", response);

            return response;

        } catch (error) {
            console.error("TransFilters Error:", error);
            toast.error("Failed to load Process filters");
        }
    };

    useEffect(() => {

        if (!fromStageId) {
            setFromSubStageVal("");
            setFromSubStageId(null);
            return;
        }

        // Selected StageID ke according SubStage find karo
        const matchedSubStages = SubStageList.filter(
            item => Number(item.StageID) === Number(fromStageId)
        );

        if (matchedSubStages.length > 0) {
            const firstSubStage = matchedSubStages[0];

            // Sub Stage automatically select
            setFromSubStageVal(firstSubStage.label);
            setFromSubStageId(firstSubStage.value);
        } else {
            // Koi matching Sub Stage nahi mili
            setFromSubStageVal("");
            setFromSubStageId(null);
        }

    }, [fromStageId, SubStageList]);

    const FilteredSubStageList = (SubStageList || []).filter(
        item => Number(item?.StageID) === Number(fromStageId)
    );

    // ==========================================
    // TOTAL ALLOCATED ISSUE METER
    // ==========================================
    const totalAllocatedIssueMeter = useMemo(() => {
        return (selected || []).reduce(
            (sum, lot) =>
                sum + (Number(lot?.issueMeter) || 0),
            0
        );
    }, [selected]);

    // ==========================================
    // AUTO CALCULATE TOTAL WEIGHT
    // Weight = Total Issue Meter × Avg Weight
    // ==========================================

    useEffect(() => {
        // Avg Weight remove karne par Weight bhi clear karo
        if (
            avgWeight === "" ||
            avgWeight === null ||
            avgWeight === undefined
        ) {
            setWeight("");

            setSelected((prev) =>
                prev.map((lot) => ({
                    ...lot,
                    _AvgWeight: "",
                    _Weight: "",
                }))
            );

            return;
        }

        const avg = Number(avgWeight);

        if (!Number.isFinite(avg)) {
            setWeight("");
            return;
        }

        // Weight calculate karo
        const calculatedWeight =
            totalAllocatedIssueMeter * avg;

        const finalWeight = calculatedWeight.toFixed(2);

        setWeight(finalWeight);

        setSelected((prev) =>
            prev.map((lot) => ({
                ...lot,
                _AvgWeight: avgWeight,
                _Weight: finalWeight,
            }))
        );
    }, [avgWeight, totalAllocatedIssueMeter]);

    const handleTreatmentChange = (selected) => {

        if (isRecipeDetailLoaded) {
            toast.warning(
                "Recipe Detail already loaded. Please create a new record to change Treatment."
            );
            return;
        }

        setTreatmentVal(selected?.label || "");
        setTreatmentId(selected?.value || null);

        const selectedTreatment = TreatmentList.find(
            item =>
                Number(item.value) ===
                Number(selected?.value ?? selected)
        );

        console.log("Selected Treatment:", selectedTreatment);

        if (!selectedTreatment) {
            setTreatmentVal("");
            setTreatmentId(null);
            return;
        }

        setTreatmentVal(selectedTreatment.label);
        setTreatmentId(selectedTreatment.value);

        console.log(
            "Selected Treatment ID:",
            selectedTreatment.value
        );
    };

    const handleRecipeChange = (selected) => {

        if (isRecipeDetailLoaded) {
            toast.warning(
                "Recipe Detail already loaded. Please create a new record to change Recipe."
            );
            return;
        }

        setRecipeVal(selected?.label || "");
        setRecipeId(selected?.value || null);

        // Dropdown se selected recipe
        const selectedRecipe = RecipeList.find(
            item =>
                Number(item.value) ===
                Number(selected?.value ?? selected)
        );

        console.log("Selected Recipe:", selectedRecipe);

        if (!selectedRecipe) {
            setRecipeVal("");
            setRecipeId(null);

            setShadeVal("");
            setShadeId(null);

            setProcessQualityVal("");
            setProcessQualityId(null);

            return;
        }

        // ================================
        // 1. Recipe Set
        // ================================
        setRecipeVal(selectedRecipe.label);
        setRecipeId(selectedRecipe.value);

        // Recipe ke andar se IDs
        const matchingId = selectedRecipe?.MatchingId;
        const qualityId = selectedRecipe?.QualityId;

        console.log("Recipe MatchingId:", matchingId);
        console.log("Recipe QualityId:", qualityId);

        // ================================
        // 2. MatchingId -> Shade
        // ================================
        const matchedShade = ShadeList.find(
            item => Number(item.value) === Number(matchingId)
        );

        console.log("Matched Shade:", matchedShade);

        if (matchedShade) {
            setShadeVal(matchedShade.label);
            setShadeId(matchedShade.value);
        } else {
            setShadeVal("");
            setShadeId(null);
        }

        // ================================
        // 3. QualityId -> Process Quality
        // ================================
        const matchedProcessQuality = ProcessQualityType.find(
            item => Number(item.value) === Number(qualityId)
        );

        console.log("Matched Process Quality:", matchedProcessQuality);

        if (matchedProcessQuality) {
            setProcessQualityVal(matchedProcessQuality.label);
            setProcessQualityId(matchedProcessQuality.value);
        } else {
            setProcessQualityVal("");
            setProcessQualityId(null);
        }
    };

    const calculateRecipeQty = (
        row,
        selected = [],
        weightValue,
        liquorValue
    ) => {
        const gpm = Number(row?.GramsPerMtr) || 0;

        if (!gpm) return 0;

        const issueMeterSum = (selected || []).reduce(
            (sum, lot) =>
                sum + (Number(lot?.issueMeter) || 0),
            0
        );

        const issueTaka = (selected || []).reduce(
            (sum, lot) =>
                sum + (Number(lot?.issueTaka) || 0),
            0
        );

        const costShortPercent =
            Number(costShPercent) ||

            0;

        let calculatedValue = gpm;

        // MTS
        if (row?.IsMActive === true) {
            let issueMeter = issueMeterSum;

            if (costShortPercent > 0) {
                issueMeter =
                    issueMeter -
                    (issueMeter * costShortPercent) / 100;
            }

            calculatedValue =
                calculatedValue * issueMeter;
        }

        // TAKA
        if (row?.IsTakaReq === true) {
            calculatedValue =
                calculatedValue * issueTaka;
        }

        // WEIGHT
        if (row?.IsWeightReq === true) {
            calculatedValue =
                calculatedValue * weightValue;
        }

        // LIQ
        if (row?.IsLIQReq === true) {
            calculatedValue =
                calculatedValue * liquorValue;
        }

        // MULTIPLIER
        const multiplier =
            Number(row?.Multiplier) || 0;

        if (multiplier > 0) {
            calculatedValue =
                calculatedValue * multiplier;
        }

        // DIVISOR
        let divisor = 1000;

        if (row?.IsLIQReq === true) {
            divisor = 1;
        } else if (row?.IsWeightReq === true) {
            divisor = 100;
        }

        const finalQty =
            calculatedValue / divisor;

        return Number(finalQty.toFixed(3));
    };

    const handleOpenRecipeDetail = async (skipAuth = false) => {

        // =========================================
        // Update se open hua hai to Auth skip
        // =========================================
        if (skipAuth) {
            console.log("Recipe Detail opened from Update - Auth skipped");
        }

        // =========================================
        // Allocated Lot check
        // =========================================
        if (!Array.isArray(selected) || selected.length === 0) {
            toast.warning("Please allocate at least one lot before opening Recipe Detail.");
            return;
        }


        const treatmentIdValue = treatmentId;
        const recipeIdValue = recipeId;

        console.log("Selected Treatment ID:", treatmentIdValue);
        console.log("Selected Recipe ID:", recipeIdValue);




        const isUpdateMode = Boolean(editingId);

        const hasExistingRecipeDetails =
            (Array.isArray(recipeDetails) && recipeDetails.length > 0) ||
            (Array.isArray(treatmentDetails) && treatmentDetails.length > 0);

        if (isUpdateMode && hasExistingRecipeDetails) {
            setIsRecipeModalOpen(true);
            return;
        }

        // Dono select nahi hai
        if (!treatmentIdValue && !recipeIdValue) {
            toast.warning("Please select Treatment or Recipe");
            return;
        }

        // Yahan se Insert-time wala logic chalega,
        // jab Recipe aur Treatment details empty hon.
        // -----------------------------------------
        // API se Treatment / Recipe detail data
        // -----------------------------------------
        const allTreatmentDetails = Array.isArray(
            TransFiltersdata?.TreatmentDtl
        )
            ? TransFiltersdata.TreatmentDtl
            : [];

        const allRecipeDetails = Array.isArray(
            TransFiltersdata?.RecipeDtl
        )
            ? TransFiltersdata.RecipeDtl
            : [];

        // -----------------------------------------
        // Treatment Detail Match
        // -----------------------------------------
        const matchedTreatmentDetails = treatmentIdValue
            ? allTreatmentDetails.filter((row) => {
                const rowId =
                    row?.ProdConsRecipeMstID ??
                    row?.ProdConsRecipeMstId;

                return Number(rowId) === Number(treatmentIdValue);
            })
            : [];

        // -----------------------------------------
        // Recipe Detail Match
        // -----------------------------------------

        const matchedRecipeDetails = recipeIdValue
            ? allRecipeDetails.filter((row) => {
                const rowId =
                    row?.ProdConsRecipeMstID ??
                    row?.ProdConsRecipeMstId;

                return Number(rowId) ===

                    (recipeIdValue);
            })
            : [];

        console.log(
            "Matched Treatment Details:",
            matchedTreatmentDetails
        );

        console.log(
            "Matched Recipe Details:",
            matchedRecipeDetails
        );


        // =====================================================
        // RECIPE / TREATMENT DETAIL API CALL
        // Har record ke ItemId par GetAvgRate call hogi
        // Aur API ka Rate usi row me add hoga
        // =====================================================

        const getRateForRows = async (rows) => {

            return await Promise.all(
                (rows || []).map(async (row, index) => {

                    const itemId =
                        row?.ItemId ??
                        row?.ItemID ??
                        null;

                    const selectedItem =
                        (AllFilterdata?.Item || []).find(
                            (item) =>
                                Number(item?.ItemId) === Number(itemId)
                        );

                    const rate1 = Number(selectedItem?.ItemRate1 ?? 0);
                    const rate2 = Number(selectedItem?.ItemRate2 ?? 0);
                    const rate3 = Number(selectedItem?.ItemRate3 ?? 0);
                    const rate4 = Number(selectedItem?.ItemRate4 ?? 0);

                    const weightValue = Array.isArray(weight)
                        ? weight.reduce(
                            (sum, field) =>
                                sum +
                                (
                                    Number(field?.Weight) ||
                                    Number(field?._Weight) ||
                                    0
                                ),
                            0
                        )
                        : (
                            Number(weight?.Weight) ||
                            Number(weight?._Weight) ||
                            Number(weight) ||
                            0
                        );

                    const liquorValue = Array.isArray(liquorVal)
                        ? liquorVal.reduce(
                            (sum, field) =>
                                sum +
                                (
                                    Number(field?.Liquor) ||
                                    Number(field?._Liquor) ||
                                    0
                                ),
                            0
                        )
                        : (
                            Number(liquorVal?.Liquor) ||
                            Number(liquorVal?._Liquor) ||
                            Number(liquorVal) ||
                            0
                        );

                    const finalQty = calculateRecipeQty(
                        row,
                        selected,
                        weightValue,
                        liquorValue
                    );

                    // =========================================
                    // AVG RATE API
                    // =========================================

                    const avgRatePayload = {
                        ToDate: formatDateDDMMYYYY(txnDate),
                        ItemID: itemId,
                    };

                    let avgRateResponse = null;

                    try {
                        avgRateResponse = await dispatch(
                            GetAvgRate(avgRatePayload)
                        ).unwrap();
                    }
                    catch (error) {
                        console.log(
                            "GetAvgRate Error:",
                            error
                        );
                    }

                    // =========================================
                    // GET AVG RATE
                    // =========================================

                    const avgRate =
                        Number(
                            avgRateResponse?.Rate[0]?.AvgRate ??

                            0
                        );

                    console.log("GetAvgRate Response:", avgRateResponse);
                    console.log("Final Avg Rate:", avgRate);
                    console.log("Final Qty:", finalQty);

                    // Qty × AvgRate
                    const finalAmount =
                        Number((finalQty * avgRate).toFixed(3));

                    // =========================================
                    // FINAL DATA
                    // =========================================

                    return {
                        ...row,

                        ItemId: itemId,

                        AvgRateResponse: avgRateResponse,

                        IssRate1: rate1,
                        IssRate2: rate2,
                        IssRate3: rate3,
                        IssRate4: rate4,

                        IssQty: finalQty,

                        IssAmount: finalAmount,

                        IssAmount1:
                            Number((finalQty * rate1).toFixed(3)),

                        IssAmount2:
                            Number((finalQty * rate2).toFixed(3)),

                        IssAmount3:
                            Number((finalQty * rate3).toFixed(3)),

                        IssAmount4:
                            Number((finalQty * rate4).toFixed(3)),
                    };
                })
            );
        };

        // =========================================
        // Treatment Detail
        // =========================================
        const updatedTreatmentDetails =
            await getRateForRows(matchedTreatmentDetails);


        // =========================================
        // Recipe Detail
        // =========================================
        const updatedRecipeDetails =
            await getRateForRows(matchedRecipeDetails);


        // =========================================
        // Set both
        // =========================================

        setTreatmentDetails(updatedTreatmentDetails);
        setRecipeDetails(updatedRecipeDetails);

        console.log(
            "Updated Treatment Details:",
            updatedTreatmentDetails
        );

        console.log(
            "Updated Recipe Details:",
            updatedRecipeDetails
        );

        // -----------------------------------------
        // Open Modal
        // -----------------------------------------

        setIsRecipeModalOpen(true);

        // -----------------------------------------
        // Lock Treatment & Recipee
        // -----------------------------------------

        setIsRecipeDetailLoaded(true);
    };

    // Styling helpers

    const bgTheme = isdark === "light" ? iscolour?.Colour3 || "#faf8f5" : iscolourDark?.Colour10 || "#1a1208";
    const textTheme = isdark === "light" ? iscolour?.Colour11 || "#8b5a2b" : iscolourDark?.Colour1 || "#fcefd9";
    const borderTheme = isdark === "light" ? iscolour?.Colour6 || "#e6a571" : iscolourDark?.Colour7 || "#7a5637";
    const bgCard = isdark === "light" ? iscolour?.Colour1 || "#ffffff" : iscolourDark?.Colour9 || "#2d1f0f";
    const btnBg = isdark === "light" ? iscolour?.Colour8 || "#D78C4D" : iscolourDark?.Colour4 || "#e19b5f";
    const btnText = isdark === "light" ? iscolour?.Colour1 || "#ffffff" : iscolourDark?.Colour10 || "#1a1208";
    const headingCol = isdark === "light" ? iscolour?.Colour9 || "#a66b35" : iscolourDark?.Colour2 || "#f5c99f";
    const accentCol = isdark === "light" ? iscolour?.Colour10 || "#c46f20" : iscolourDark?.Colour4 || "#e19b5f";
    const inputBg = isdark === "light" ? iscolour?.Colour4 || "#fef3e8" : iscolourDark?.Colour8 || "#6b4423";
    const hoverBg = isdark === "light" ? iscolour?.Colour5 || "#fde9d3" : iscolourDark?.Colour7 || "#7a5637";

    // Keypress event handler for F5 and F7

    React.useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "F5") {

                e.preventDefault();
                setIsHelpModalOpen(true);

            }
            if (e.key === "F7") {

                e.preventDefault();
                setIsStoppageModalOpen(true);

            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, []);

    console.log(
        TransShowOnedata?.Main?.[0]?.TransTypeID
    );


    const helpmodelopen = async (HelpModel) => {

        // =====================================================
        // AGAR ALLOCATED ROLL EMPTY NAHI HAI
        // TO API CALL MAT KARO
        // =====================================================
        if (
            !editingId &&
            Array.isArray(selected) &&
            selected.length > 0
        ) {
            console.log(
                "Allocated Roll me record already hai."
            );

            console.log(
                "LotPendHelp API call nahi hogi."
            );
            console.log(
                "Insert mode: Allocated lots already exist, Lot Help API blocked."
            );

            return;
        }

        try {

            console.log(
                "Allocated Roll empty hai - LotPendHelp API call hogi."
            );

            const response = await dispatch(
                LotPendHelp({
                    FirmID: FirmID,
                    TransTypeID: gateTxnId,
                    RecvBy: processId,

                    SubStageID: fromSubStageId,
                    GroupID: HelpModel?.groupId,
                    PartyID: HelpModel?.partyId,
                    QualityID: HelpModel?.qualityId,

                })
            ).unwrap();

            const helpData = Array.isArray(response)
                ? response
                : response?.LotPendHelp || [];

            setOriginalAvailableLots(helpData);
            setISHelpModal(helpData);

        } catch (error) {

            console.error(
                "LotPendHelp Error:",
                error
            );

            toast.error(
                " Failed to load Lot Help data "
            );
        }
    };

    // Add a new stoppage entry row
    const handleAddStoppageRow = () => {
        const newRow = {
            id: "S" + Date.now().toString().slice(-6),
            startTime: getCurrentDateTimeLocal(),
            endTime: "",
            diff: "",
            reason: ""
        };
        setStoppageEntries([...stoppageEntries, newRow]);
    };

    // Update a field inside a specific stoppage row
    const handleUpdateStoppageField = (id, field, value) => {
        setStoppageEntries(prevEntries => prevEntries.map(entry => {
            if (entry.id === id) {
                const updated = { ...entry, [field]: value };
                if (field === "startTime" || field === "endTime") {
                    updated.diff = calculateDiff(updated.startTime, updated.endTime);
                }
                return updated;
            }
            return entry;
        }));
    };

    // Difference calculator helper
    const calculateDiff = (start, end) => {
        if (!start || !end) return "";
        const s = new Date(start);
        const e = new Date(end);
        const diffMs = e - s;
        if (diffMs < 0) return "Invalid";
        const diffMins = Math.floor(diffMs / 60000);
        const hrs = Math.floor(diffMins / 60);
        const mins = diffMins % 60;
        return hrs > 0 ? `${hrs}h ${mins}m` : `${mins}m`;
    };

    // Delete all selected stoppage rows
    const handleDeleteSelectedStoppages = () => {
        const remaining = stoppageEntries.filter(entry => !selectedStoppageRows[entry.id]);
        setStoppageEntries(remaining);
        setSelectedStoppageRows({});
        toast.success("Selected stoppage rows removed");
    };

    // Confirm/save stoppage details
    const handleSaveStoppageDetails = () => {
        const totalDuration = stoppageEntries.reduce((acc, entry) => {
            if (!entry.startTime || !entry.endTime) return acc;
            const ms = new Date(entry.endTime) - new Date(entry.startTime);
            return ms > 0 ? acc + Math.floor(ms / 60000) : acc;
        }, 0);
        toast.success(`Stoppage log updated. Total Stoppage Duration: ${totalDuration} R`);
        setIsStoppageModalOpen(false);
    };

    const getFinancialYearDates = (selectedYear) => {
        const dateRange = selectedYear?.AcYear;

        if (!dateRange) {
            return null;
        }

        const [fromDate, toDate] = dateRange
            .split(" - ")
            .map((date) => date.trim());

        if (!fromDate || !toDate) {
            return null;
        }

        const convertToSQLDate = (date) => {
            const [day, month, year] = date.split("/");

            if (!day || !month || !year) {
                return null;
            }

            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
        };

        const formattedFromDate = convertToSQLDate(fromDate);
        const formattedToDate = convertToSQLDate(toDate);

        if (!formattedFromDate || !formattedToDate) {
            return null;
        }

        return {
            FromDate: formattedFromDate,
            ToDate: formattedToDate,
        };
    };

    const handleGo = async () => {
        if (!gateStageId) {
            toast.warning("Please select a Destination Stage");
            return;
        }

        if (!gateTxnId) {
            toast.warning("Please select a Transaction Type");
            return;
        }

        const FinancialYear = Cookies.get("FinancialYear");
        const FirmID = Cookies.get("Firm");

        const selectedYear = DataMain?.AC_Year_List?.find(
            (item) =>
                String(item.AcYearID) === String(FinancialYear)
        );

        if (!selectedYear) {
            toast.warning("Financial Year not found");
            return;
        }

        const financialYearDates =
            getFinancialYearDates(selectedYear);

        if (!financialYearDates) {
            toast.warning("Invalid Financial Year date range");
            return;
        }

        setIsGateLoading(true);

        try {

            // ==========================================
            // TransShowAll + TransFilters API
            // ==========================================

            const [transShowAllResponse, transFiltersResponse, stageSrNoResponse, appSetupDetailResponse] =
                await Promise.all([
                    dispatch(
                        TransShowAll({
                            TransTypeID: gateTxnId,
                            ProcessMstID: ProcessMstID,
                            FromDate: financialYearDates.FromDate,
                            ToDate: financialYearDates.ToDate,
                        })
                    ).unwrap(),

                    dispatch(
                        TransFilters({
                            FirmID: String(FirmID || ""),
                            TransTypeID: String(gateTxnId || ""),
                        })
                    ).unwrap(),

                    dispatch(
                        GetStageSrNo({
                            FirmID: String(FirmID || ""),
                            TransTypeID: String(gateTxnId || ""),
                            Date: txnDate,
                        })
                    ).unwrap(),

                    // ==========================================
                    // AppSetupDetail API
                    // ==========================================
                    dispatch(
                        AppSetupDetail({
                            FirmID: String(FirmID || ""),
                        })
                    ).unwrap(),
                ]);



            setAppSetupDetaildata(appSetupDetailResponse);

            // ==========================================
            // API Responses
            // ==========================================

            console.log(
                "TransShowAll Response:",
                transShowAllResponse
            );

            console.log(
                "TransFilters Response:",
                transFiltersResponse
            );

            console.log(
                "appSetupDetail Response:",
                appSetupDetailResponse
            );

            // ==========================================
            // Stage Set
            // ==========================================

            setFromStageVal(gateStageVal);
            setFromStageId(gateStageId);

            // ==========================================
            // Gate Passed
            // ==========================================

            setIsGatePassed(true);

            toast.success(
                "Stage Access Verified Successfully"
            );

            // ==========================================
            // Scroll Workspace
            // ==========================================

            setTimeout(() => {
                document
                    .getElementById("lot-entry-workspace")
                    ?.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                    });
            }, 100);

        } catch (error) {
            console.error(
                "TransShowAll / TransFilters Error:",
                error
            );

            toast.error(
                "Failed to verify stage access"
            );

        } finally {
            setIsGateLoading(false);
        }
    };

    // Reset form
    const resetForm = () => {
        // ==========================================
        // TRANSACTION MASTER DETAILS
        // ==========================================
        setSrNo("");
        setFromStageVal("");
        setFromStageId(null);

        setToMachineVal("");
        setToMachineId(null);

        setFromSubStageVal("");
        setFromSubStageId(null);

        setProcessVal("");
        setProcessId(null);

        setProcessQualityVal("");
        setProcessQualityId(null);

        setRemark("");

        // ==========================================
        // REDESIGN / MASTER DROPDOWNS
        // ==========================================
        setTreatmentVal("");
        setTreatmentId(null);

        setTreatmentId(null);
        setTreatmentVal(null);


        setRecipeVal("");
        setRecipeId(null);

        setProcessTypeVal("");
        setProcessTypeId(null);

        setMachineVal("");
        setMachineId(null);

        setShadeVal("");
        setShadeId(null);


        setCostShPercent("")

        dispatch(clearTransFilters());

        // ==========================================
        // OPERATIONAL PARAMETERS
        // ==========================================
        setOperatorVal("");
        setOperatorId(null);

        setLiquorVal("");
        setLiquorId(null);

        setBatchNo("");
        setMillVal("");
        setProgVal("");
        setProgDateVal("");

        setShiftVal("");

        // Time bhi blank
        setInTime("");
        setOutTime("");

        setWeight("");
        setAvgWeight("");
        setChartNo("");

        // ==========================================
        // RECIPE DETAILS
        // ==========================================
        setRecipeDetails([]);
        setTreatmentDetails([]);
        setIsRecipeDetailLoaded(false);

        // ==========================================
        // RECEIPT DETAIL
        // ==========================================
        setDetails([]);
        setMappedDetails([]);

        // ==========================================
        // TO STAGE DETAIL / SUB DETAIL
        // ==========================================
        setSubMianDetails([]);

        // ==========================================
        // ALLOCATED ROLL LOTS
        // ==========================================
        setSelected([]);

        // ==========================================
        // AVAILABLE ROLL LOTS
        // ==========================================
        setAvailable([]);

        // ==========================================
        // CHECKBOXES
        // ==========================================
        setCheckedAvailable({});
        setCheckedSelected({});

        // ==========================================
        // SEARCH
        // ==========================================
        setSearchAvailable("");
        setSearchSelected("");

        // ==========================================
        // ALLOCATION MODAL
        // ==========================================
        setLotsToAllocate([]);
        setAllocationErrors({});
        setIsAllocationModalOpen(false);

        // ==========================================
        // TAKA DETAIL
        // ==========================================
        setSelectedTakas({});
        setTakaSearch("");
        setTakaQty("");
        setIsTakaDetailOpen(false);

        // ==========================================
        // STOPPAGE DETAIL
        // ==========================================
        setStoppageEntries([]);
        setSelectedStoppageRows({});
        setIsStoppageModalOpen(false);

        // ==========================================
        // RECIPE MODAL
        // ==========================================
        setIsRecipeModalOpen(false);

        // ==========================================
        // HELP MODAL DATA
        // ==========================================
        setISHelpModal([]);
        setIsHelpModalOpen(false);

        // ==========================================
        // VALIDATION / EDIT STATES
        // ==========================================
        setEditingId(null);
        setErrors({});

        // ==========================================
        // DATE
        // ==========================================
        setTxnDate(new Date().toISOString().split("T")[0]);

        // ==========================================
        // ADDING STATE
        // ==========================================
        setIsAdding(false);
    };

    const handleRecipeDetailRowsChange = (rows) => {
        const allRows = Array.isArray(rows) ? rows : [];

        const updatedTreatmentDetails = allRows.filter(
            (row) => row?.DetailType === "Treatment"
        );

        const updatedRecipeDetails = allRows.filter(
            (row) => row?.DetailType === "Recipe"
        );

        setTreatmentDetails(updatedTreatmentDetails);
        setRecipeDetails(updatedRecipeDetails);

        setIsRecipeDetailLoaded(allRows.length > 0);
    };

    // Trigger New Record setup

    const handleNew = () => {
        resetForm();

        setIsAdding(true);

        // =====================================
        // FROM STAGE - FIRST RECORD AUTO SELECT
        // =====================================
        const firstStage = StageList1?.[0];

        if (firstStage) {
            setFromStageVal(firstStage.label);
            setFromStageId(firstStage.value);
        }

        // =====================================
        // DATE & TIME
        // =====================================
        const now = getCurrentDateTimeLocal();

        setTxnDate(now);
        setInTime(now);
        setOutTime(now);
        setProgDateVal(now);

        // =====================================
        // STAGE SR NO
        // =====================================
        const stageSrNo =
            GetStageSrNodata?.StageSrNo?.[0]?.StageSrNo;

        if (stageSrNo !== undefined && stageSrNo !== null) {
            setSrNo(String(stageSrNo));
        }

        // TO MACHINE - FIRST RECORD AUTO SELECT
        const firstMachine = ToStageList?.[0];

        if (firstMachine) {
            setToMachineVal(firstMachine.label);
            setToMachineId(firstMachine.value);
        }
    };


    const formatDateTimeLocal = (value) => {
        if (!value) return "";

        const date = new Date(value);

        if (isNaN(date.getTime())) return "";

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");

        return `${year}-${month}-${day}T${hours}:${minutes}`;
    };

    const formatDateDDMMYYYY = (date) => {
        if (!date) return "";

        const d = new Date(date);

        if (isNaN(d.getTime())) return "";

        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();

        return `${year}-${month}-${day}`;
    };

    // Handle Edit Record selection

    const handleEdit = async (row) => {
        if (!row?.id) return;

        try {

            const checkResponse = await dispatch(
                TransDeleteCheck({
                    MainID: row.id,
                })
            ).unwrap();

            console.log(
                "Update TransDeleteCheck Response:",
                checkResponse
            );


            const response = await dispatch(
                TransShowOne({
                    MainID: row.id
                })
            ).unwrap();

            console.log("TransShowOne Response:", response);

            // API response ka actual record
            const rec = Array.isArray(response)
                ? response[0]
                : response?.data?.[0] || response?.[0] || response;

            if (!rec) {
                toast.warning("Transaction details not found");
                return;
            }


            // ==========================================
            // Store Complete API Response
            // ==========================================


            const transactionData = {

                Main: Array.isArray(response?.Main)
                    ? response.Main
                    : [],

                Detail: Array.isArray(response?.Detail)
                    ? response.Detail
                    : [],

                SubDetail: Array.isArray(response?.SubDetail)
                    ? response.SubDetail
                    : [],

                RecipeDetail: Array.isArray(response?.RecipeDetail)
                    ? response.RecipeDetail
                    : [],

                ExFieldsValue: Array.isArray(response?.ExFieldsValue)
                    ? response.ExFieldsValue
                    : []


            };

            setTransactionData(transactionData);


            console.log(
                "Complete Transaction Data:",
                transactionData
            );


            // ==========================================
            // Individual Data
            // ==========================================

            const mainData = transactionData.Main[0] || null;

            const detailData = transactionData.Detail;

            const subDetailData = transactionData.SubDetail;

            const recipeDetailData =
                transactionData.RecipeDetail;

            const exFieldsValue =
                transactionData.ExFieldsValue;

            console.log("Main Data:", mainData);
            console.log("Detail Data:", detailData);
            console.log("SubDetail Data:", subDetailData);
            console.log("RecipeDetail Data:", recipeDetailData);
            console.log("ExFieldsValue:", exFieldsValue);

            if (!mainData) {
                toast.warning("Transaction details not found");
                return;
            }

            const processMstId =
                mainData?.ProcessByMasterID ??
                mainData?.ProcessMstID ??
                null;

            const processTypeId =
                mainData?.ProcessTypeID ??
                null;

            console.log("EDIT ProcessMstID:", processMstId);
            console.log("EDIT ProcessTypeID:", processTypeId);

            await handleProcessFilter({
                ProcessMstID: processMstId,
                ProcessTypeID: processTypeId,
            });

            // ==========================================
            // Edit Form Fill - Main Data
            // ==========================================

            setEditingId(
                mainData?.TransID || row.id
            );

            // Transaction Date

            const transactionDate = formatDateTimeLocal(
                mainData?.TDate
            );

            console.log(transactionDate);


            setTxnDate(transactionDate);

            // Stage Sr No

            setSrNo(
                mainData?.StageSrNo || ""
            );

            // From Stage

            const stageId = detailData?.[0]?.StageID || null;

            console.log(stageId);

            const si = StageList.find(
                s =>
                    Number(s.value) ===
                    Number(stageId)
            );

            setFromStageVal(
                si
                    ? si.label
                    : (stageId || "")
            );

            setFromStageId(
                stageId
            );


            // Machine

            const TomachineId = mainData?.ToSubStageID || null;

            const mc = ToStageList.find(
                m =>
                    Number(m.value) ===
                    Number(TomachineId)
            );

            setToMachineVal(
                mc
                    ? mc.label
                    : (TomachineId || "")
            );

            setToMachineId(
                TomachineId
            );

            // From Sub Stage

            const subStageId =
                mainData?.SubStageID || null;

            const sub = SubStageList.find(
                s =>
                    Number(s.value) ===
                    Number(subStageId)
            );

            setFromSubStageVal(
                sub
                    ? sub.label
                    : (subStageId || "")
            );

            setFromSubStageId(
                subStageId
            );


            // Process Type

            const ProcessTypeID =
                mainData?.ProcessTypeID ?? null;


            const pt1 = ProcessTypeList.find(
                p1 =>
                    Number(p1.value) ===
                    Number(ProcessTypeID)
            );

            setProcessTypeVal(
                pt1
                    ? pt1.label
                    : (ProcessTypeID || "")
            );

            setProcessTypeId(ProcessTypeID);

            // Process

            const processId =
                mainData?.RecvBy || null;


            const pr = ProcessMstList.find(
                p =>
                    Number(p.value) ===
                    Number(processId)
            );


            setProcessVal(
                pr
                    ? pr.label
                    : (processId || "")
            );

            setProcessId(processId);


            // Remark

            setRemark(
                mainData?.LotRemark || ""
            );


            // Recipe 

            const RecipeMstID =
                mainData?.ProdConsRecipeMstID || null;

            const Rr = RecipeList.find(
                R =>
                    Number(R.value) ===
                    Number(RecipeMstID)
            );

            setRecipeVal(
                Rr
                    ? Rr.label
                    : (RecipeMstID || "")
            );

            setRecipeId(RecipeMstID);

            // Recipe 

            const TreatmentID = mainData?.TreatmentMstID ?? null;

            const matchedTreatment = TreatmentList.find(
                item => Number(item.value) === Number(TreatmentID)
            );

            setTreatmentId(TreatmentID);
            setTreatmentVal(matchedTreatment?.label || "");


            // Shade 

            const ShadeId =
                mainData?.MatchingId || null;

            const s = ShadeList.find(
                s =>
                    Number(s.value) ===
                    Number(ShadeId)
            );

            setShadeVal(
                s
                    ? s.label
                    : (ShadeId || "")
            );

            setShadeId(ShadeId);


            // Machine

            const MachineId = mainData?.MachineId ?? null;

            const matchedMachine = MatchingList.find(
                item => Number(item.value) === Number(MachineId)
            );

            setMachineId(MachineId);
            setMachineVal(matchedMachine?.label || "");



            const QualityId = mainData?.ProcessQualityId ?? null;

            const matchedQuality = ProcessQualityType.find(
                item => Number(item.value) === Number(QualityId)
            );

            setProcessQualityId(QualityId);
            setProcessQualityVal(matchedQuality?.label || "");


            //CostShPer

            setCostShPercent(mainData?.CostShPer)

            // // ==========================================
            // // Recipe Details
            // // ==========================================

            // const mappedRecipeDetailData = (recipeDetailData || []).map((recipe) => {

            //     const itemId =
            //         recipe?.ItemId ??
            //         recipe?.ItemID ??
            //         null;

            //     const itemSubGroupId =
            //         recipe?.ItemProcessGroupID ??
            //         recipe?.ItemProcessGroupID ??
            //         null;



            //     const ItemProcessGroupID =
            //         recipe?.ItemProcessGroupID ??
            //         recipe?.ItemProcessGroupID ??
            //         null;

            //     // ItemId -> Item Name
            //     const matchedItem = ItemList.find(
            //         (item) =>
            //             Number(item.value) === Number(itemId)
            //     );

            //     // ItemSubGroupId -> Item Sub Group Name
            //     const matchedItemSubGroup = ItemSubGroupList.find(
            //         (subGroup) =>
            //             Number(subGroup.value) === Number(itemSubGroupId)
            //     );

            //     const ItemProcessGroup = ProcessGrpList.find(
            //         (ProcessGroup) =>
            //             Number(ProcessGroup.value) === Number(ItemProcessGroupID)
            //     );

            //     return {
            //         ...recipe,

            //         // Original IDs bhi rahenge
            //         ItemId: itemId,
            //         ItemSubGroupId: itemSubGroupId,
            //         ItemProcessGroupID: ItemProcessGroupID,

            //         // Matched Names
            //         ItemName: matchedItem?.label || "-",
            //         ItemSubGroupName: matchedItemSubGroup?.label || "-",
            //         ItemShort: matchedItem?.value1 || "-",
            //         ProcessGroup: ItemProcessGroup?.label || "-"
            //     };
            // });

            // console.log(
            //     "Mapped Recipe Detail:",
            //     mappedRecipeDetailData
            // );

            // setRecipeDetails(mappedRecipeDetailData);


            // ==========================================
            // UPDATE TIME - RESTORE SAVED RECIPE DETAIL
            // ==========================================

            const savedRecipeDetails = Array.isArray(recipeDetailData)
                ? recipeDetailData
                : [];

            const mappedRecipeDetailData = savedRecipeDetails.map((recipe) => {
                const itemId = recipe?.ItemId ?? recipe?.ItemID ?? null;

                const itemSubGroupId =
                    recipe?.ItemProcessGroupID ?? null;

                const matchedItem = ItemList.find(
                    (item) => Number(item.value) === Number(itemId)
                );

                const matchedItemSubGroup = ItemSubGroupList.find(
                    (item) => Number(item.value) === Number(itemSubGroupId)
                );

                const matchedProcessGroup = ProcessGrpList.find(
                    (item) => Number(item.value) === Number(itemSubGroupId)
                );

                return {
                    ...recipe,

                    ItemId: itemId,
                    ItemSubGroupId: itemSubGroupId,
                    ItemProcessGroupID: itemSubGroupId,

                    ItemName: matchedItem?.label || recipe?.ItemName || "-",
                    ItemShort: matchedItem?.value1 || recipe?.ItemShort || "-",
                    ItemSubGroupName:
                        matchedItemSubGroup?.label ||
                        recipe?.ItemSubGroupName ||
                        "-",

                    ProcessGroup:
                        matchedProcessGroup?.label ||
                        recipe?.ProcessGroup ||
                        "-",
                };
            });

            // Saved transaction detail ko state mein restore karo
            setRecipeDetails(
                mappedRecipeDetailData.filter(
                    (row) => row?.DetailType !== "Treatment"
                )
            );

            setTreatmentDetails(
                mappedRecipeDetailData.filter(
                    (row) => row?.DetailType === "Treatment"
                )
            );

            setIsRecipeDetailLoaded(savedRecipeDetails.length > 0);


            // ==========================================
            // Other fields - ExFieldsValue
            // ==========================================

            const exData = Array.isArray(exFieldsValue)
                ? exFieldsValue?.[0] || {}
                : exFieldsValue || {};

            console.log("EX FIELD DATA:", exData);

            setParamId(
                exData?.ParamId
            )


            // _AvgWeight

            setAvgWeight(
                exData?._AvgWeight ?? ""
            );


            // _BatchNo

            setBatchNo(
                exData?._BatchNo ?? ""
            );

            // _ChartNo

            setChartNo(
                exData?._ChartNo ?? ""
            );

            // _InTime

            setInTime(
                exData?._InTime
                    ? formatDateTimeLocal(exData._InTime)
                    : ""
            );

            // _Liquor

            setLiquorVal(
                exData?._Liquor ?? ""
            );


            // _MILL

            setMillVal(
                exData?._MILL ?? ""
            );


            // _Operator

            setOperatorVal(
                exData?._Operator ?? ""
            );


            // _OutTime

            setOutTime(
                exData?._OutTime
                    ? formatDateTimeLocal(exData._OutTime)
                    : ""
            );

            // _PROG

            setProgVal(
                exData?._PROG ?? ""
            );

            // _PROGDATE

            setProgDateVal(
                exData?._PROGDATE
                    ? formatDateTimeLocal(exData._PROGDATE)
                    : ""
            );

            // _Shift
            setShiftVal(
                exData?._Shift ?? ""
            );


            // _Weight
            setWeight(
                exData?._Weight ?? ""
            );


            // ==========================================
            // Allocation lot
            // ==========================================

            // const mappedDetailData = (detailData || []).map((detail) => {

            //     const groupId =
            //         detail?.GroupId ??
            //         detail?.GroupID ??
            //         null;

            //     const qualityId =
            //         detail?.QualityId ??
            //         detail?.QualityID ??
            //         null;

            //     // GroupId -> GroupName
            //     const matchedGroup = GroupList.find(
            //         (group) =>
            //             Number(group.value) === Number(groupId)
            //     );

            //     // QualityId -> QualityType
            //     const matchedQuality = QualityType.find(
            //         (quality) =>
            //             Number(quality.value) === Number(qualityId)
            //     );

            //     return {
            //         ...detail,

            //         GroupId: groupId,
            //         QualityId: qualityId,

            //         GroupName: matchedGroup?.label || "-",
            //         QualityName: matchedQuality?.label || "-"
            //     };
            // });

            // const mappedAllocatedLots = (detailData || []).map((lot) => ({
            //     ...lot,

            //     id: lot?.InwCode ?? lot?.inwCode ?? lot?.DetailCode,
            //     InwCode: lot?.InwCode ?? lot?.inwCode ?? lot?.DetailCode,

            //     lotNo: lot?.LotNo ?? lot?.lotNo ?? "",
            //     LotNo: lot?.LotNo ?? lot?.lotNo ?? "",

            //     inwDate: lot?.InwDate ?? lot?.inwDate ?? "",
            //     inwSrNo: lot?.InwSrNo ?? lot?.inwSrNo ?? "",

            //     acName: lot?.AcName ?? lot?.acName ?? "",
            //     pty: lot?.ShortACName ?? lot?.pty ?? "",

            //     groupName: lot?.GroupName ?? lot?.groupName ?? "",
            //     quality:
            //         lot?.QualityType ??
            //         lot?.quality ??
            //         lot?.QualityName ??
            //         lot?.Quality ??
            //         "",

            //     issueTaka: Number(
            //         lot?.TakaCount ??
            //         0
            //     ),

            //     issueMeter: Number(
            //         lot?.Qty ??
            //         0
            //     ),

            //     _Operator:
            //         lot?._Operator ??
            //         lot?.Operator ??
            //         lot?.operator ??
            //         "",

            //     _Shift:
            //         lot?._Shift ??
            //         lot?.Shift ??
            //         lot?.shift ??
            //         "",

            //     _InTime:
            //         lot?._InTime ??
            //         lot?.InTime ??
            //         lot?.intime ??
            //         "",

            //     _OutTime:
            //         lot?._OutTime ??
            //         lot?.OutTime ??
            //         lot?.outtime ??
            //         "",

            //     _AvgWeight: Number(
            //         lot?._AvgWeight ??
            //         lot?.AvgWeight ??
            //         lot?.avgWeight ??
            //         0
            //     ),

            //     _Weight: Number(
            //         lot?._Weight ??
            //         lot?.Weight ??
            //         lot?.weight ??
            //         0
            //     ),

            //     source: "update",
            // }));

            // console.log("EDIT ALLOCATED LOTS:", mappedAllocatedLots);

            // setSelected(mappedAllocatedLots);






            const savedSubDetails = Array.isArray(transactionData?.SubDetail)
                ? transactionData.SubDetail
                : [];

            const mappedAllocatedLots = (detailData || []).map((lot) => {
                // Lot ka Inward ID
                const lotInwCode = String(
                    lot?.InwCode ??
                    lot?.inwCode ??
                    lot?.InwardID ??
                    lot?.InwardId ??
                    ""
                );

                // Current allocated detail ID
                const lotTransDtlID =
                    lot?.TransDtlID ??
                    lot?.TransDetailID ??
                    lot?.DetailID ??
                    null;

                // SubDetail ko pehle TransDtlID se match karo,
                // phir InwardID se fallback match karo.
                const lotSubDetails = savedSubDetails.filter((sub) => {
                    const subTransDtlID =
                        sub?.TransDtlID ??
                        sub?.TransDetailID ??
                        sub?.DetailID ??
                        null;

                    const subInwardID = String(
                        sub?.InwCode ??
                        sub?.InwardID ??
                        sub?.InwardId ??
                        sub?.inwardCode ??
                        ""
                    );

                    const detailIdMatched =
                        lotTransDtlID != null &&
                        subTransDtlID != null &&
                        String(lotTransDtlID) === String(subTransDtlID);

                    const inwardIdMatched =
                        lotInwCode !== "" &&
                        subInwardID === lotInwCode;

                    return detailIdMatched || inwardIdMatched;
                });

                // Taka rows ko normalize karo
                const selectedTakasForLot = lotSubDetails.map((sub, index) => {
                    const qty = Number(
                        sub?.Qty ??
                        sub?.issueMeter ??
                        sub?.IssueMeter ??
                        sub?.IssueQty ??
                        0
                    );

                    return {
                        ...sub,

                        TransSubDtlID: sub?.TransSubDtlID ?? 0,
                        TransDtlID: sub?.TransDtlID ?? lotTransDtlID ?? 0,

                        InwCode:
                            sub?.InwCode ??
                            sub?.InwardID ??
                            sub?.InwardId ??
                            lotInwCode,

                        InwardID:
                            sub?.InwardID ??
                            sub?.InwCode ??
                            sub?.InwardId ??
                            lotInwCode,

                        issueMeter: qty.toFixed(2),

                        ShortMeter: Number(
                            sub?.Shortage ??
                            sub?.ShortMeter ??
                            sub?.short ??
                            0
                        ).toFixed(2),

                        Balance: Number(
                            sub?.Balance ??
                            sub?.balance ??
                            sub?.BalMeter ??
                            0
                        ),

                        rowId:
                            sub?.rowId ??
                            `${sub?.TransDtlID ?? lotTransDtlID ?? "row"}_${index}`,

                        ToStageID: sub?.ToStageID ?? "",
                        ToSubStageID: sub?.ToSubStageID ?? "",
                        InwFirmId: sub?.InwFirmId ?? 0,
                        InwAcYear: sub?.InwAcYear ?? "",
                    };
                });

                // SubDetail se total calculate karo
                const issueMeterFromSubDetails = selectedTakasForLot.reduce(
                    (sum, taka) => sum + (Number(taka?.issueMeter) || 0),
                    0
                );

                // Agar SubDetail match nahi hua to Detail ke saved totals use karo
                const issueTaka =
                    selectedTakasForLot.length > 0
                        ? selectedTakasForLot.length
                        : Number(
                            lot?.TotalCount ??
                            lot?.SelectedTaka ??
                            lot?.IssueTaka ??
                            lot?.issueTaka ??
                            0
                        );

                const issueMeter =
                    selectedTakasForLot.length > 0
                        ? issueMeterFromSubDetails
                        : Number(
                            lot?.TotalQty ??
                            lot?.Qty ??
                            lot?.IssueMeter ??
                            lot?.issueMeter ??
                            0
                        );

                return {
                    ...lot,

                    id: lotInwCode,
                    InwCode: lotInwCode,

                    lotNo: lot?.LotNo ?? lot?.lotNo ?? "",
                    LotNo: lot?.LotNo ?? lot?.lotNo ?? "",

                    inwDate: lot?.InwDate ?? lot?.inwDate ?? "",
                    inwSrNo: lot?.InwSrNo ?? lot?.inwSrNo ?? "",

                    acName: lot?.AcName ?? lot?.acName ?? "",
                    pty: lot?.ShortACName ?? lot?.pty ?? "",

                    groupName: lot?.GroupName ?? lot?.groupName ?? "",
                    quality:
                        lot?.QualityType ??
                        lot?.quality ??
                        lot?.QualityName ??
                        lot?.Quality ??
                        "",

                    // Update mode mein totals
                    issueTaka,
                    issueMeter: Number(issueMeter.toFixed(2)),

                    source: "update",
                    selectedTakas: selectedTakasForLot,
                };
            });

            console.log("UPDATE - saved SubDetail:", savedSubDetails);
            console.log("UPDATE - mapped allocated lots:", mappedAllocatedLots);

            setSelected(mappedAllocatedLots);

            const hasAllocatedLots =
                Array.isArray(mappedAllocatedLots) &&
                mappedAllocatedLots.length > 0;


            // ==========================================
            // sub Detail 
            // ==========================================


            // const subDetailMianData = (subDetailData || []).map((detail) => {

            //     const groupId =
            //         detail?.GroupId ??
            //         detail?.GroupID ??
            //         null;

            //     const qualityId =
            //         detail?.QualityId ??
            //         detail?.QualityID ??
            //         null;

            //     // GroupId -> GroupName
            //     const matchedGroup = GroupList.find(
            //         (group) =>
            //             Number(group.value) === Number(groupId)
            //     );

            //     // QualityId -> QualityType
            //     const matchedQuality = QualityType.find(
            //         (quality) =>
            //             Number(quality.value) === Number(qualityId)
            //     );

            //     return {
            //         ...detail,

            //         GroupId: groupId,
            //         QualityId: qualityId,

            //         GroupName: matchedGroup?.label || "-",
            //         QualityName: matchedQuality?.label || "-"
            //     };
            // });

            // console.log(" Sub Detail: ", subDetailMianData);
            // console.log("Mapped Detail:", mappedDetailData);

            // setSubMianDetails(subDetailMianData);

            // const selectedLots = rec.selectedLots || [];

            // setSelected(selectedLots);


            // const remainingAvailable = INITIAL_AVAILABLE

            //     .map(item => {
            //         const matchInSel = selectedLots.find(
            //             s => s.id === item.id
            //         );

            //         if (matchInSel) {
            //             const takaLeft =
            //                 item.taka - (matchInSel.issueTaka || 0);

            //             const meterLeft =
            //                 item.meter - (matchInSel.issueMeter || 0);

            //             return {
            //                 ...item,
            //                 taka: takaLeft,
            //                 meter: meterLeft
            //             };
            //         }

            //         return item;
            //     })
            //     .filter(
            //         item =>
            //             item.taka > 0 ||
            //             item.meter > 0
            //     );

            // setAvailable(remainingAvailable);


            // Available checkbox reset
            setCheckedAvailable({});

            // Selected checkbox reset
            setCheckedSelected({});

            setIsAdding(true);
            setErrors({});

        } catch (error) {
            console.error(
                "TransShowOne Error:",
                error
            );

            toast.error(
                "Failed to load transaction details"
            );
        }
    };

    useEffect(() => {
        // if (!isEditMode) return;

        if (!TransFiltersdata?.Treatment?.length) return;

        const selectedTreatment = TransFiltersdata.Treatment.find(
            item =>
                Number(item?.TreatmentMstID) ===
                Number(treatmentId)
        );

        if (selectedTreatment) {
            setTreatmentId(selectedTreatment.TreatmentMstID);
            setTreatmentVal(
                selectedTreatment.Treatment
            );
        }
    }, [
        // isEditMode,
        TransFiltersdata?.Treatment,
        treatmentId
    ]);

    useEffect(() => {
        // if (!isEditMode) return;

        if (!TransFiltersdata?.Recipe?.length) return;

        const selectedRecipe = TransFiltersdata.Recipe.find(
            item =>
                Number(item?.ProdConsRecipeMstID) ===
                Number(recipeId)
        );

        if (selectedRecipe) {
            setRecipeId(selectedRecipe.ProdConsRecipeMstID);
            setRecipeVal(
                selectedRecipe.RecipeCode
            );
        }
    }, [
        // isEditMode,
        TransFiltersdata?.Recipe,
        recipeId
    ]);


    const handleDelete = (row) => {
        setRowToDeleteId(row.id);
        setShowConfirmModal(true);
    };

    // Perform Delete
    const executeDelete = async () => {
        if (!rowToDeleteId) {
            toast.warning("Record ID not found");
            return;
        }

        try {
            setIsLoading(true);

            // 1. Pehle TransDeleteCheck API call
            const checkResponse = await dispatch(
                TransDeleteCheck({
                    MainID: rowToDeleteId,
                })
            ).unwrap();

            console.log(
                "TransDeleteCheck Response:",
                checkResponse
            );

            // API response se dono details nikalo
            const forwardDtl =
                checkResponse?.ForwrdDtl ??
                checkResponse?.data?.ForwrdDtl ??
                [];

            const issSlipDtl =
                checkResponse?.IssSlipDtl ??
                checkResponse?.data?.IssSlipDtl ??
                [];

            // ==========================================
            // 2. CONDITION: ForwrdDtl
            // Isme data hai to delete block hoga
            // ==========================================
            const hasForwardData = Array.isArray(forwardDtl)
                ? forwardDtl.length > 0
                : forwardDtl != null &&
                    typeof forwardDtl === "object"
                    ? Object.keys(forwardDtl).length > 0
                    : Boolean(forwardDtl);

            if (hasForwardData) {
                toast.warning(
                    "This record cannot be deleted because forward details exist."
                );

                setShowConfirmModal(false);
                return; // DELETE YAHIN RUK JAYEGA
            }

            // ==========================================
            // 3. CONDITION: IssSlipDtl
            // IsPostedIssueSlip true ho to delete block hoga
            // ==========================================
            const issueSlipRows = Array.isArray(issSlipDtl)
                ? issSlipDtl
                : issSlipDtl
                    ? [issSlipDtl]
                    : [];

            const isPostedIssueSlip = issueSlipRows.some((item) => {
                const value = item?.IsPostedIssueSlip;

                return (
                    value === true ||
                    value === 1 ||
                    ["true", "1"].includes(
                        String(value).toLowerCase()
                    )
                );
            });

            if (isPostedIssueSlip) {
                toast.warning(
                    "This record cannot be deleted because the Issue Slip is posted."
                );

                setShowConfirmModal(false);
                return; // DELETE YAHIN RUK JAYEGA
            }


            // ==========================================
            // 1. DELETE API CALL
            // ==========================================
            const response = await dispatch(
                TransDelete({
                    MainID: rowToDeleteId
                })
            ).unwrap();

            console.log("TransDelete Response:", response);

            // ==========================================
            // 2. DELETE SUCCESS - MODAL CLOSE
            // ==========================================
            setShowConfirmModal(false);

            if (
                String(editingId) === String(rowToDeleteId)
            ) {
                resetForm();
            }

            setRowToDeleteId(null);

            toast.success("Lot Entry record deleted successfully");

            // ==========================================
            // 3. FINANCIAL YEAR DATES
            // ==========================================
            const FinancialYear = Cookies.get("FinancialYear");

            const selectedYear = DataMain?.AC_Year_List?.find(
                (item) =>
                    String(item.AcYearID) === String(FinancialYear)
            );

            const financialYearDates =
                getFinancialYearDates(selectedYear);

            if (!financialYearDates) {
                toast.warning(
                    "Record deleted, but table refresh dates are invalid."
                );
                return;
            }

            // ==========================================
            // 4. RECALL TABLE API
            // ==========================================
            try {
                const refreshedData = await dispatch(
                    TransShowAll({
                        TransTypeID: gateTxnId,
                        ProcessMstID: ProcessMstID,
                        FromDate: financialYearDates.FromDate,
                        ToDate: financialYearDates.ToDate
                    })
                ).unwrap();

                console.log(
                    "TransShowAll After Delete:",
                    refreshedData
                );

                toast.info("Table data refreshed successfully");
            } catch (refreshError) {
                console.error(
                    "Table Refresh Error:",
                    refreshError
                );

                toast.warning(
                    "Record deleted, but table refresh failed. Please retry."
                );
            }

        } catch (error) {
            console.error("TransDelete Error:", error);

            toast.error(
                error?.message ||
                "Failed to delete Lot Entry record"
            );
        } finally {
            setIsLoading(false);
        }

    };




    // const handleInsert = async () => {



    //     const master = {
    //         TransID: editingId || "",
    //         TransTypeID: gateTxnId,
    //         StageSrNo: srNo,
    //         StageSrNoSeq: "",
    //         TDate: txnDate,
    //         ToSubStageID: fromSubStageId,
    //         FirmID: FirmID,

    //         JoberOutwardSrNo: "",
    //         RecvDateTime: txnDate,
    //         RecvBy: processId,
    //         UserID: "",

    //         IsMultipleToSubStage: "",
    //         TrollyCount: "",
    //         BatchSrNoSeq: "0",

    //         ProcessTypeID: processTypeId,
    //         IsOpening: false,

    //         LotRemark: "",
    //         AcYear: "",
    //         SlipNo: "",
    //         SlipNoSeq: "",

    //         IsCancelSlip: "",
    //         MachineId: machineId,
    //         QualityGroupId: "",
    //         ShadeId: shadeId,

    //         ProcessQuality: processQualityId,

    //         InwFirmId: "",
    //         InwAcYear: "",

    //         UserDateTime: txnDate,

    //         ProdDtlIdBook2: "",
    //         ProdDtlIdBook3: "",
    //         IsUpdated: "",
    //         PrvGreyInwardID: "",

    //         Imported: "",
    //         BlanketID: "",

    //         MName: shadeVal,
    //         MatchingId: recipeMachineId,

    //         TreatmentMstID: treatmentId,
    //         RecipeMstID: recipeId,

    //         CostShPer: costShPercent,
    //         ProcessByMasterID: processId
    //     };

    //     const detail = (selected || []).map((lot, index) => {



    //         const selectedTakas = Array.isArray(lot?.selectedTakas)
    //             ? lot.selectedTakas
    //             : [];

    //         // 0 INDEX TAKA
    //         const firstTaka = selectedTakas[0] || {};

    //         // ==========================================
    //         // SELECTED TAKAS ISSUE METER TOTAL
    //         // ==========================================
    //         // const totalIssueMeter = selectedTakas.reduce(
    //         //     (sum, taka) =>
    //         //         sum + (Number(taka?.issueMeter) || 0),
    //         //     0
    //         // );

    //         return {

    //             TransDtlID:
    //                 lot?.TransDtlID || 0,

    //             TransID:
    //                 editingId || 0,

    //             FromTransID:
    //                 lot?.FromTransID || 0,

    //             FromStageID:
    //                 fromStageId || "",

    //             FromSubStageID:
    //                 fromSubStageId || "",

    //             ToSubStageID:
    //                 lot?.ToSubStageID || "",

    //             InwardID:
    //                 lot?.InwCode || "",

    //             FromTransDtlID:
    //                 lot?.DetailCode || "",

    //             TotalQty:
    //                 lot?.issueMeter || "",

    //             TotalCount:
    //                 lot?.issueTaka || "",

    //             // ==========================================
    //             // SELECTED TAKAS ISSUE METER KA TOTAL
    //             // ==========================================
    //             Shortage: lot?.issueMeter || 0,

    //             SrNo:
    //                 index + 1,

    //             TotEmbTaka:
    //                 lot?.TotEmbTaka || 0,

    //             // ==========================================
    //             // 0 INDEX SELECTED TAKA SE
    //             // ==========================================

    //             InwFirmId:
    //                 firstTaka?.InwFirmId || 0,

    //             InwAcYear:
    //                 firstTaka?.InwAcYear || "",

    //             Balance:
    //                 lot?.issueMeter || "",

    //             SelectedTaka:
    //                 lot?.SelectedTaka ||
    //                 lot?.IssueTaka ||
    //                 0,

    //             ShortagePer:
    //                 firstTaka?.shortStage ||
    //                 lot?.ShortPercent ||
    //                 0,

    //             LocationDtlId:
    //                 selectedTakas
    //                     .map(taka => taka?.LocationDtlId)
    //                     .filter(
    //                         id =>
    //                             id !== null &&
    //                             id !== undefined
    //                     )
    //         };
    //     });

    //     const subdetail = (selected || []).flatMap((lot) => {

    //         const selectedTakas = Array.isArray(lot?.selectedTakas)
    //             ? lot.selectedTakas
    //             : [];

    //         return selectedTakas.map((taka, takaIndex) => ({

    //             TransSubDtlID:
    //                 taka?.TransSubDtlID || 0,

    //             TransDtlID:
    //                 taka?.TransDtlID || 0,

    //             TransID:
    //                 editingId || 0,

    //             FromSubStageID:
    //                 taka?.ToStageID || "",

    //             ToSubStageID:
    //                 taka?.ToSubStageID || "",

    //             InwardID:
    //                 taka?.InwCode || "",

    //             InwardDtlID:
    //                 taka?.InwardDtlID ||
    //                 0,

    //             Qty:
    //                 taka?.issueMeter || 0,

    //             Shortage:
    //                 taka?.ShortMeter || "",

    //             FromTransDtlID:
    //                 lot?.DetailCode || "",

    //             FromTransSubID:
    //                 taka?.FromTransSubID || 0,

    //             SrNo:
    //                 taka?.SrNo || takaIndex + 1,

    //             ToStageID:
    //                 taka?.ToStageID || "",

    //             TakaCount:
    //                 taka?.TakaCount ||
    //                 taka?.issueTaka ||
    //                 1,

    //             InwFirmId:
    //                 taka?.InwFirmId || 0,

    //             InwAcYear:
    //                 taka?.InwAcYear || "",

    //             Balance:
    //                 taka?.Balance ||
    //                 taka?.issueMeter ||
    //                 0

    //         }));
    //     });

    //     const exFieldsValue = [
    //         {
    //             ParamId: "28950",

    //             TransID:
    //                 editingId || 0,

    //             _MILL:
    //                 millVal || "",

    //             _Shift:
    //                 shiftVal || "",

    //             _InTime:
    //                 inTime || "",

    //             _OutTime:
    //                 outTime || "",

    //             _Weight:
    //                 weight || "0",

    //             _ChartNo:
    //                 chartNo || "",

    //             _BatchNo:
    //                 batchNo || "",

    //             _AvgWeight:
    //                 avgWeight || "",

    //             _PROG:
    //                 progVal || "",

    //             _Liquor:
    //                 liquorVal || "",

    //             _PROGDATE:
    //                 progDateVal || "",

    //             _Operator:
    //                 operatorVal || ""
    //         }
    //     ];

    //     const recdetail = [
    //         ...(treatmentDetails || []),
    //         ...(recipeDetails || [])
    //     ].map((row) => ({
    //         TransConsRecipeDtlId:
    //             row?.TransConsRecipeDtlId ??
    //             row?.TransConsRecipeDtlID ??
    //             0,

    //         TransID:
    //             editingId || 0,

    //         ItemId:
    //             row?.ItemId ??
    //             row?.ItemID ??
    //             0,

    //         GramsPerMtr:
    //             row?.GramsPerMtr ?? 0,

    //         IsWeightReq:
    //             row?.IsWeightReq ?? "",

    //         IsQtyReq:
    //             row?.IsQtyReq ?? "",

    //         Multiplier:
    //             row?.Multiplier ?? "",

    //         SubProcessName:
    //             row?.SubProcessName ?? "",

    //         TempNHoldTime:
    //             row?.TempNHoldTime ?? "",

    //         IsTakaReq:
    //             row?.IsTakaReq ?? "",

    //         RecipeSubProcessId:
    //             row?.RecipeSubProcessId ?? 0,

    //         MName:
    //             row?.MName ?? "",

    //         IsMActive:
    //             row?.IsMActive ?? "",

    //         ItemProcessGroupID:
    //             row?.ItemProcessGroupID ?? 0,

    //         ProdConsRecipeDtlId:
    //             row?.ProdConsRecipeDtlId ??
    //             row?.ProdConsRecipeDtlID ??
    //             0,

    //         ProdConsRecipeMstId:
    //             row?.ProdConsRecipeMstId ??
    //             row?.ProdConsRecipeMstID ??
    //             recipeId ??
    //             0,

    //         IsLIQReq:
    //             row?.IsLIQReq ?? "",

    //         IssQty:
    //             row?.IsWeightReq ?? 0,

    //         IssRate:
    //             row?.IssRate ?? 0,

    //         IssAmount:
    //             row?.IssAmount ?? 0,

    //         IssAvgRate:
    //             row?.IssAvgRate ?? 0,

    //         IssRate1: row?.IssRate1 ?? "",
    //         IssRate2: row?.IssRate2 ?? "",
    //         IssRate3: row?.IssRate3 ?? "",
    //         IssRate4: row?.IssRate4 ?? "",

    //         IssAmount1: row?.IssAmount1 ?? "",
    //         IssAmount2: row?.IssAmount2 ?? "",
    //         IssAmount3: row?.IssAmount3 ?? "",
    //         IssAmount4: row?.IssAmount4 ?? ""
    //     }));

    //     // 3️⃣ API BODY
    //     const body = {
    //         master: master,
    //         detail: detail,
    //         subdetail: subdetail,
    //         recdetail: recdetail,
    //         ExFieldsValue: exFieldsValue,
    //     };

    //     console.log(body);

    //     const response = await dispatch(
    //         TransInsert(body)
    //     ).unwrap();

    // };


    const handleInsert = async () => {

        // =====================================
        // REQUIRED FIELD VALIDATION
        // =====================================
        const newErrors = {};

        if (
            fromStageId === null ||
            fromStageId === undefined ||
            fromStageId === ""
        ) {
            newErrors.fromStageId = "From Stage is required";
        }

        if (
            fromSubStageId === null ||
            fromSubStageId === undefined ||
            fromSubStageId === ""
        ) {
            newErrors.fromSubStageId = "From Sub Stage is required";
        }

        if (
            toMachineId === null ||
            toMachineId === undefined ||
            toMachineId === ""
        ) {
            newErrors.toMachineId = "Machine is required";
        }

        if (
            machineId === null ||
            machineId === undefined ||
            machineId === ""
        ) {
            newErrors.machineId = "Machine is required";
        }

        if (
            processId === null ||
            processId === undefined ||
            processId === ""
        ) {
            newErrors.processId = "Process is required";
        }

        if (
            processQualityId === null ||
            processQualityId === undefined ||
            processQualityId === ""
        ) {
            newErrors.processQualityId = "Process Quality is required";
        }

        if (
            processTypeId === null ||
            processTypeId === undefined ||
            processTypeId === ""
        ) {
            newErrors.processTypeId = "Process Type is required";
        }

        if (
            costShPercent === null ||
            costShPercent === undefined ||
            String(costShPercent).trim() === ""
        ) {
            newErrors.costShPercent = "Cost Short (%) is required";
        }

        // Koi bhi required field blank hai to insert stop
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);

            toast.warning(
                Object.values(newErrors)[0]
            );

            return; // TransInsert API call nahi hogi
        }

        // Sab fields valid hain
        setErrors({});

        try {

            const stageSrNoSeq = Number(srNo?.split("/").pop()) || 0;

            const master = {
                TransID: editingId || 0,
                TransTypeID: gateTxnId,
                StageSrNo: srNo,
                StageSrNoSeq: stageSrNoSeq,
                TDate: formatDateDDMMYYYY(txnDate),
                ToSubStageID: toMachineId,
                FirmID: FirmID,

                JoberOutwardSrNo: "",
                RecvDateTime: formatDateDDMMYYYY(txnDate),
                RecvBy: processId,
                UserID: userId,

                IsMultipleToSubStage: false,
                TrollyCount: "",
                BatchSrNoSeq: "0",

                ProcessTypeID: processTypeId,
                IsOpening: false,

                LotRemark: "",
                AcYear: "",
                SlipNo: "",
                SlipNoSeq: "",

                IsCancelSlip: false,
                MachineId: machineId,
                QualityGroupId: 0,
                ShadeId: shadeId,

                ProcessQuality: processQualityId,

                InwFirmId: 0,
                InwAcYear: "",

                UserDateTime: formatDateDDMMYYYY(txnDate),

                ProdDtlIdBook2: "",
                ProdDtlIdBook3: "",
                IsUpdated: "",
                PrvGreyInwardID: "",

                Imported: false,
                BlanketID: 0,

                MName: shadeVal,
                MatchingId: recipeMachineId,

                TreatmentMstID: treatmentId,
                RecipeMstID: recipeId,

                CostShPer: costShPercent,
                ProcessByMasterID: processId
            };

            const detail = (selected || []).map((lot, index) => {

                const selectedTakas = Array.isArray(lot?.selectedTakas)
                    ? lot.selectedTakas
                    : [];

                // 0 INDEX TAKA
                const firstTaka = selectedTakas[0] || {};


                const totalIssueMeter = selectedTakas.reduce(
                    (sum, taka) =>
                        sum + (Number(taka?.ShortMeter) || 0),
                    0
                );




                return {

                    TransDtlID:
                        lot?.TransDtlID || 0,

                    TransID:
                        editingId || 0,

                    FromTransID: firstTaka?.TransSubDtlTransID || 0,

                    FromStageID:
                        fromStageId || "",

                    FromSubStageID:
                        fromSubStageId || "",

                    ToSubStageID:
                        lot?.ToSubStageID || "",

                    InwardID:
                        lot?.InwCode || "",

                    FromTransDtlID:
                        lot?.TransDtlID || lot?.DetailCode,

                    TotalQty:
                        lot?.issueMeter || "",

                    TotalCount:
                        lot?.issueTaka || "",

                    // ==========================================
                    // SELECTED TAKAS ISSUE METER KA TOTAL
                    // ==========================================

                    Shortage: totalIssueMeter || 0,

                    SrNo:
                        index + 1,

                    TotEmbTaka:
                        lot?.TotEmbTaka || 0,

                    // ==========================================
                    // 0 INDEX SELECTED TAKA SE
                    // ==========================================

                    InwFirmId:
                        firstTaka?.InwFirmId || 0,

                    InwAcYear:
                        firstTaka?.InwAcYear || "",

                    Balance:
                        lot?.issueMeter || "",

                    SelectedTaka:
                        lot?.SelectedTaka ||
                        lot?.IssueTaka ||
                        0,

                    ShortagePer:
                        firstTaka?.shortStage ||
                        lot?.ShortPercent ||
                        0,

                    LocationDtlId: 0,

                };
            });


            const subdetail = (selected || []).flatMap((lot, index) => {
                const selectedTakas = Array.isArray(lot?.selectedTakas)
                    ? lot.selectedTakas
                    : [];

                return selectedTakas.map((taka) => ({
                    TransSubDtlID: taka?.TransSubDtlID ?? 0,
                    TransDtlID: taka?.TransDtlID ?? lot?.TransDtlID ?? 0,
                    TransID: editingId || 0,

                    FromSubStageID: taka?.FromSubStageID ?? taka?.ToStageID ?? "",
                    ToSubStageID: taka?.ToSubStageID ?? "",
                    InwardID: taka?.InwardID ?? taka?.InwCode ?? "",
                    InwardDtlID: taka?.InwardDtlID ?? 0,

                    Qty: Number(taka?.issueMeter ?? taka?.Qty ?? 0),
                    Shortage: Number(
                        taka?.ShortMeter ?? taka?.Shortage ?? taka?.short ?? 0
                    ),

                    FromTransDtlID: lot?.DetailCode ?? lot?.TransDtlID ?? "",
                    FromTransSubID: taka?.TransSubDtlID ?? 0,

                    SrNo: index + 1,
                    ToStageID: taka?.ToStageID ?? "",
                    TakaCount: 1,

                    InwFirmId: taka?.InwFirmId ?? 0,
                    InwAcYear: taka?.InwAcYear ?? "",
                    Balance: taka?.Balance ?? 0,
                }));
            });

            console.log("FINAL SUBDETAIL:", subdetail);
            console.log("transaction Data:", transactionData);

            const exFieldsValue = [
                {
                    ParamId: ParamId,

                    TransID:
                        editingId || 0,

                    _MILL:
                        millVal || "",

                    _Shift:
                        shiftVal || "",

                    _InTime:
                        formatDateDDMMYYYY(inTime) || "",

                    _OutTime:
                        formatDateDDMMYYYY(outTime) || "",

                    _Weight:
                        weight || "0",

                    _ChartNo:
                        chartNo || "",

                    _BatchNo:
                        batchNo || "",

                    _AvgWeight:
                        avgWeight || "",

                    _PROG:
                        progVal || "",

                    _Liquor:
                        liquorVal || "",

                    _PROGDATE:
                        formatDateDDMMYYYY(progDateVal) || "",

                    _Operator:
                        operatorVal || ""
                }
            ];

            const recdetail = [
                ...(treatmentDetails || []),
                ...(recipeDetails || [])
            ].map((row) => {

                // Avg Rate API se lena
                const avgRate =
                    Number(row?.AvgRateResponse?.AvgRate?.[0]?.AvgRate) || 0;

                // Rate API response se rate lena
                const rateData = row?.AvgRateResponse?.Rate?.[0] || {};

                const rate =
                    Number(
                        rateData?.AvgRate ??
                        rateData?.IssRate ??
                        row?.IssRate1 ??
                        0
                    ) || 0;

                return {
                    TransConsRecipeDtlId:
                        row?.TransConsRecipeDtlId ??
                        row?.TransConsRecipeDtlID ??
                        0,

                    TransID: editingId || 0,

                    ItemId: row?.ItemId ?? row?.ItemID ?? 0,

                    GramsPerMtr: row?.GramsPerMtr ?? 0,

                    IsWeightReq: row?.IsWeightReq ?? "",
                    IsQtyReq: row?.IsQtyReq ?? "",
                    Multiplier: row?.Multiplier ?? "",
                    SubProcessName: row?.SubProcessName ?? "",
                    TempNHoldTime: row?.TempNHoldTime ?? "",
                    IsTakaReq: row?.IsTakaReq ?? false,
                    RecipeSubProcessId: row?.RecipeSubProcessId ?? 0,
                    MName: row?.MName ?? "",
                    IsMActive: row?.IsMActive ?? false,
                    ItemProcessGroupID: row?.ItemProcessGroupID ?? 0,

                    ProdConsRecipeDtlId:
                        row?.ProdConsRecipeDtlId ??
                        row?.ProdConsRecipeDtlID ??
                        0,

                    ProdConsRecipeMstId:
                        row?.ProdConsRecipeMstId ??
                        row?.ProdConsRecipeMstID ??
                        recipeId ??
                        0,

                    IsLIQReq: row?.IsLIQReq ?? false,

                    IssQty: row?.IssQty ?? 0,

                    // Rate
                    IssRate: rate,

                    // Average Rate
                    IssAvgRate: avgRate,

                    IssRate1: row?.IssRate1 ?? rate,
                    IssRate2: row?.IssRate2 ?? 0,
                    IssRate3: row?.IssRate3 ?? 0,
                    IssRate4: row?.IssRate4 ?? 0,

                    IssAmount: row?.IssAmount ?? 0,

                    IssAmount1: row?.IssAmount1 ?? 0,
                    IssAmount2: row?.IssAmount2 ?? 0,
                    IssAmount3: row?.IssAmount3 ?? 0,
                    IssAmount4: row?.IssAmount4 ?? 0
                };
            });

            const body = {
                master,
                detail,
                subdetail,
                recdetail,
                exflds: exFieldsValue,
                MainID: editingId,
                TransTypeID: gateTxnId,
                ProcessMstID: ProcessMstID
            };

            const isUpdate = Boolean(editingId);

            console.log("API SubDetail:", transactionData.SubDetail);

            console.log(
                "Selected lots with Taka:",
                selected.map(lot => ({
                    InwCode: lot.InwCode,
                    selectedTakas: lot.selectedTakas
                }))
            );

            console.log("FINAL SUBDETAIL:", subdetail);

            console.log(
                isUpdate ? "TRANS UPDATE BODY:" : "TRANS INSERT BODY:",
                JSON.stringify(body, null, 2)
            );

            console.log("SELECTED LOTS:", selected);

            console.log(
                "LOT-WISE SELECTED TAKAS:",
                selected.map(lot => ({
                    InwCode: lot?.InwCode,
                    selectedTakas: lot?.selectedTakas
                }))
            );

            console.log("FINAL SUBDETAIL:", subdetail);

            const response = isUpdate
                ? await dispatch(TransUpdate(body)).unwrap()
                : await dispatch(TransInsert(body)).unwrap();

            console.log(
                isUpdate ? "TRANS UPDATE SUCCESS:" : "TRANS INSERT SUCCESS:",
                response
            );

            console.log("TRANS INSERT SUCCESS:", response);

            // Table ka data reload karo
            const FinancialYear = Cookies.get("FinancialYear");

            const selectedYear = DataMain?.AC_Year_List?.find(
                (item) =>
                    String(item.AcYearID) === String(FinancialYear)
            );

            const financialYearDates = getFinancialYearDates(selectedYear);

            if (!financialYearDates) {
                toast.warning("Record saved, but Financial Year dates are invalid.");
                return;
            }

            await dispatch(
                TransShowAll({
                    TransTypeID: gateTxnId,
                    ProcessMstID: ProcessMstID,
                    FromDate: financialYearDates.FromDate,
                    ToDate: financialYearDates.ToDate,
                })
            ).unwrap();

            // Sirf successful insert aur table refresh ke baad

            resetForm();
            setIsAdding(false);
            setEditingId(null);

            toast.success(
                isUpdate
                    ? "Record updated successfully!"
                    : "Record inserted successfully!"
            );

        } catch (error) {

            console.log("========== TRANS INSERT FAILED ==========");
            console.log("ERROR OBJECT:", error);

            console.log(
                "ERROR JSON:",
                JSON.stringify(error, null, 2)
            );

            console.log(
                "ERROR MESSAGE:",
                error?.message
            );

            console.log(
                "ERROR RESPONSE:",
                error?.response?.data
            );
        }
    };


    // Save / Update logic

    // const handleSave = () => {

    //     const newErrors = {};
    //     if (!srNo || !srNo.trim()) {
    //         newErrors.srNo = "Voucher Serial Number is required";
    //     }

    //     if (selected.length === 0) {
    //         newErrors.lots = "Please allocate at least one lot to this transaction";
    //         toast.error("Please allocate at least one lot before saving");
    //     }

    //     if (Object.keys(newErrors).length > 0) {
    //         setErrors(newErrors);
    //         return;
    //     }

    //     const payloadParams = {
    //         // shift: shiftId || "ShiftA",
    //         inTime,
    //         outTime,
    //         weight,
    //         chartNo,
    //         avgWeight
    //     };

    //     setIsLoading(true);
    //     setTimeout(() => {
    //         if (editingId) {
    //             setRecords(records.map(rec => {
    //                 if (rec.id === editingId) {
    //                     return {
    //                         ...rec,
    //                         txnDate,
    //                         srNo,
    //                         fromStage: fromStageVal,
    //                         toMachine: toMachineId,
    //                         fromSubStage: fromSubStageId,
    //                         process: processId,
    //                         remark,
    //                         treatment: treatmentId,
    //                         recipe: recipeId,
    //                         processType: processTypeId,
    //                         machine: machineId,
    //                         shade: shadeId,
    //                         params: payloadParams,
    //                         selectedLots: selected
    //                     };
    //                 }
    //                 return rec;
    //             }));
    //             toast.success("Record updated successfully");
    //         } else {
    //             const newRec = {
    //                 id: "TXN" + Date.now().toString().slice(-6),
    //                 txnDate,
    //                 srNo,
    //                 fromStage: fromStageVal,
    //                 toMachine: toMachineId,
    //                 fromSubStage: fromSubStageId,
    //                 process: processId,
    //                 remark,
    //                 treatment: treatmentId,
    //                 recipe: recipeId,
    //                 processType: processTypeId,
    //                 machine: machineId,
    //                 shade: shadeId,
    //                 params: payloadParams,
    //                 selectedLots: selected
    //             };
    //             setRecords([newRec, ...records]);
    //             toast.success("Record saved successfully");
    //         }

    //         setIsLoading(false);
    //         resetForm();
    //     }, 900);
    // };



    // =========================================
    // SAFE SEARCH HELPER
    // ==========================================
    const safeText = (value) =>
        String(value ?? "").toLowerCase();

    // ==========================================
    // AVAILABLE LOTS FILTER
    // ==========================================
    const filteredAvailable = (Array.isArray(available) ? available : []).filter(
        (lot) => {
            const q = safeText(searchAvailable);

            return (
                safeText(lot?.lotNo).includes(q) ||
                safeText(lot?.acName).includes(q) ||
                safeText(lot?.quality).includes(q)
            );
        }
    );

    // ==========================================
    // ALLOCATED LOTS FILTER
    // ==========================================
    const filteredSelected = (Array.isArray(selected) ? selected : []).filter(
        (lot) => {
            const q = safeText(searchSelected);

            return (
                safeText(lot?.lotNo).includes(q) ||
                safeText(lot?.acName).includes(q) ||
                safeText(lot?.quality).includes(q)
            );
        }
    );

    // ==========================================
    // SAVED RECORDS FILTER
    // ==========================================
    const filteredRecords = (Array.isArray(records) ? records : []).filter(
        (rec) => {
            const q = safeText(searchRecords);
            const selectedLots = Array.isArray(rec?.selectedLots)
                ? rec.selectedLots
                : [];

            return (
                safeText(rec?.srNo).includes(q) ||
                safeText(rec?.fromStage).includes(q) ||
                safeText(rec?.remark).includes(q) ||
                selectedLots.some(
                    (lot) =>
                        safeText(lot?.lotNo).includes(q) ||
                        safeText(lot?.acName).includes(q)
                )
            );
        }
    );




    const formatDate = (dateString) => {
        if (!dateString) return "-";

        const date = new Date(dateString);

        if (isNaN(date.getTime())) return "-";

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        console.log();


        return `${day}/${month}/${year}`;
    };

    const tableColumns = [
        { label: "Trans ID", key: "transId", align: "center" },
        { label: "Stage Sr No", key: "stageSrNo", align: "left" },
        { label: "Date", key: "tDate", align: "left" },
        { label: "Account Name", key: "acName", align: "left" },
        { label: "Lot No", key: "LotNo", align: "left" },
        { label: "From Sub Stage", key: "fromSubStage", align: "left" },
        { label: "Taka", key: "taka", align: "center" },
        { label: "Meters", key: "meters", align: "right" },
        { label: "Batch Sr No", key: "BatchSrNoSeq", align: "center" },
    ];

    const tableRows = (TransShowAlldata?.Data || []).map((item) => ({
        id: item.TransID,
        stageSrNo: item.StageSrNo || "-",
        tDate: formatDate(item.TDate),
        acName: item.AcName || "-",
        LotNo: item.LotNo || "-",
        fromSubStage: item.FromSubStage || "-",
        taka: item.Taka ?? 0,
        meters: item.Meters ?? 0,
        BatchSrNoSeq: item.BatchSrNoSeq ?? 0,
    }));

    const moveSelectedRight = async () => {

        // ==========================================
        // 1. Selected checkbox IDs
        // ==========================================
        const checkedIds = Object.keys(checkedAvailable)
            .filter(id => checkedAvailable[id]);

        if (checkedIds.length === 0) {
            toast.warning(
                "Please select at least one lot from the Available grid"
            );
            return;
        }

        console.log("Checked InwCodes:", checkedIds);

        // ==========================================
        // 2. LotPendHelp API ka actual data
        // ==========================================
        const helpLots = Array.isArray(LotPendHelpdata?.LotPendHelp)
            ? LotPendHelpdata.LotPendHelp
            : Array.isArray(LotPendHelpdata)
                ? LotPendHelpdata
                : [];

        console.log("LotPendHelp Data:", helpLots);

        // ==========================================
        // 3. Selected records InwCode se find karo
        // ==========================================

        const selectedRows = helpLots.filter((lot) => {

            const inwCode = String(lot?.InwCode ?? "");

            return checkedIds.includes(inwCode);
        });

        console.log("Selected LotPendHelp Rows:", selectedRows);

        // ==========================================
        // 4. InwCode ki queue banao
        // ==========================================

        const queueIds = selectedRows
            .map(lot => lot?.InwCode)
            .filter(Boolean)
            .map(String);

        console.log("Taka Detail Queue - InwCode:", queueIds);

        // ==========================================
        // 5. Agar InwCode nahi mili
        // ==========================================

        if (queueIds.length === 0) {
            toast.error("Selected lot ka InwCode nahi mila");
            return;
        }

        // ==========================================
        // 6. Queue save
        // ==========================================

        setTakaDetailQueue(queueIds);
        setTakaDetailIndex(0);

        // ==========================================
        // 7. First selected lot ka Taka Detail open
        // ==========================================

        await openTakaDetailForLot(queueIds[0]);

    };

    const openTakaDetailForLot = async (
        lotId,
        existingAllocation = null
    ) => {

        if (!lotId) {
            return;
        }

        // Existing allocated record edit mode
        if (existingAllocation) {
            setEditingAllocatedLot(existingAllocation);
        }

        // ==========================================
        // LotPendHelp ka actual data
        // ==========================================

        const helpLots = Array.isArray(LotPendHelpdata?.LotPendHelp)
            ? LotPendHelpdata.LotPendHelp
            : Array.isArray(LotPendHelpdata)
                ? LotPendHelpdata
                : [];

        // ==========================================
        // Selected Lot -> DetailCode se find
        // ==========================================
        const selectedLot = existingAllocation
            ? existingAllocation
            : helpLots.find(
                lot =>
                    String(lot?.InwCode) === String(lotId)
            );

        console.log("Processing Lot:", selectedLot);
        console.log("Lot ID:", lotId);
        console.log("Existing Allocation:", existingAllocation);

        if (!selectedLot) {
            toast.warning(
                `Selected lot record not found for ID: ${lotId}`
            );
            return;
        }

        if (!selectedLot?.InwCode) {
            toast.error(
                `Selected lot me DetailCode nahi mila: ${lotId}`
            );
            return;
        }

        // ==========================================
        // API Payload
        // ==========================================

        const payload = {
            FirmID: FirmID,
            TransDtlID: String(
                selectedLot?.DetailCode ??
                selectedLot?.TransDtlID ??
                ""
            ),
            InwCode: String(selectedLot?.InwCode ?? ""),
            FromStageID: fromStageId,
            FromSubStageID: fromSubStageId,
            ToSubStageID: String(selectedLot?.ToSubStageID ?? ""),
            TransTypeID: gateTxnId,
        };

        console.log(
            "TransSubDtlInsertHelp Payload:",
            payload
        );

        try {

            setIsLoading(true);

            // ==========================================
            // Previous Taka Detail data clear
            // ==========================================
            setDetails([]);
            setSubMianDetails([]);
            setSelectedTakas({});
            setTakaSearch("");
            setTakaQty("");

            // ==========================================
            // API Call
            // ==========================================
            const response = await dispatch(
                TransSubDtlInsertHelp(payload)
            ).unwrap();

            const takaSubDetails = response?.TakaSubDtl || [];
            const takaDetails = response?.TakaDtl || [];

            setSubMianDetails(takaSubDetails);
            setDetails(takaDetails);

            setSelectedAvailableLot(selectedLot);

            // =====================================================
            // RESTORE TAKA SELECTION
            // =====================================================

            const restoredSelected = {};
            const restoredMeters = {};

            // =====================================================
            // CASE 1:
            // ALL BUTTON SE ALLOCATE HUA HAI
            // =====================================================
            if (selectedLot?.isAllocatedByAll === true) {

                console.log(
                    "ALL ALLOCATION → ALL TAKA SELECT"
                );

                takaSubDetails.forEach((row, index) => {

                    const rowId =
                        `${row?.TransDtlID ?? "row"}_${index}`;

                    // ALL se allocate hua hai
                    // isliye har Taka checked
                    restoredSelected[rowId] = true;

                    // Issue Meter restore
                    restoredMeters[rowId] =
                        Number(row?.BalMeter ?? 0).toFixed(2);

                });
            }

            // =====================================================
            // CASE 2:
            // MANUAL ALLOCATION
            // =====================================================
            else {

                console.log(
                    "MANUAL ALLOCATION → ONLY SAVED TAKA SELECT"
                );

                const savedTakas =
                    existingAllocation?.selectedTakas || [];

                takaSubDetails.forEach((row, index) => {

                    const rowId =
                        `${row?.TransDtlID ?? "row"}_${index}`;

                    const saved = savedTakas.find(
                        item =>
                            String(item?.rowId) ===
                            String(rowId)
                    );

                    // Sirf manually selected Taka
                    if (saved) {

                        restoredSelected[rowId] = true;

                        restoredMeters[rowId] =
                            Number(
                                saved?.issueMeter ?? 0
                            ).toFixed(2);
                    }
                });
            }

            // =====================================================
            // STATE SET
            // =====================================================

            console.log(
                "RESTORED SELECTED:",
                restoredSelected
            );

            console.log(
                "RESTORED METERS:",
                restoredMeters
            );

            setSelectedTakas(restoredSelected);

            setInitialIssueMeterValues(restoredMeters);

            setTakaQty(
                String(
                    Object.keys(restoredSelected).length
                )
            );

            // ==========================================
            // OPEN MODAL
            // ==========================================
            setIsTakaDetailOpen(true);


        } catch (error) {

            console.error(
                "TransSubDtlInsertHelp Error:",
                error
            );

            toast.error(
                error?.message ||
                "Failed to load Show Detail"
            );

        } finally {

            setIsLoading(false);

        }
    };

    const handleTakaDetailComplete = async ({
        selectedTakas,
        issueMeterValues,

        // HEADER FIELDS
        shortStage,
        headerTaka,
        greyMtrs,
        location

    }) => {

        console.log("fdkjlhgfdsghjkl;jhg", issueMeterValues);
        console.log("kljhjkljhljljkjh", selectedTakas);

        const currentLotId =
            takaDetailQueue[takaDetailIndex] ??
            editingAllocatedLot?.InwCode ??
            selectedAvailableLot?.InwCode;

        if (!currentLotId) {
            setIsTakaDetailOpen(false);
            return;
        }





        // ==========================================
        // Current lot find karo - InwCode se
        // ==========================================

        const helpLots = Array.isArray(LotPendHelpdata?.LotPendHelp)
            ? LotPendHelpdata.LotPendHelp
            : Array.isArray(LotPendHelpdata)
                ? LotPendHelpdata
                : [];

        const currentLot =
            (editingAllocatedLot &&
                String(editingAllocatedLot?.InwCode) === String(currentLotId))
                ? editingAllocatedLot
                : (selectedAvailableLot &&
                    String(selectedAvailableLot?.InwCode) === String(currentLotId))
                    ? selectedAvailableLot
                    : helpLots.find(
                        lot => String(lot?.InwCode) === String(currentLotId)
                    );

        if (!currentLot) {
            console.error("Current lot not found:", {
                currentLotId,
                editingAllocatedLot,
                selectedAvailableLot,
                helpLots
            });

            toast.error("Current lot record not found");
            return;
        }

        // ==========================================
        // SELECTED TAKA IDS
        // ==========================================

        const selectedTakaIds = Object.keys(selectedTakas || {})
            .filter(id => selectedTakas[id]);

        const selectedTakaRows = (SubMianDetails || [])
            .map((row, index) => {

                const rowId =
                    `${row?.TransDtlID ?? "row"}_${index}`;

                if (!selectedTakaIds.includes(rowId)) {
                    return null;
                }

                const balanceMeter = Number(row?.BalMeter ?? 0);

                const issueMeter = Number(
                    issueMeterValues?.[rowId] ?? 0
                );

                // Short Meter = Balance Meter - Issue Meter
                const shortMeter = Math.max(
                    balanceMeter - issueMeter,
                    0
                );

                return {
                    ...row,

                    rowId,

                    // =========================
                    // ISSUE METER
                    // =========================
                    issueMeter: issueMeter.toFixed(2),

                    // =========================
                    // SHORT METER
                    // =========================
                    shortMeter: shortMeter.toFixed(2),

                    // =========================
                    // HEADER DATA
                    // =========================
                    shortStage: Number(shortStage || 0),
                    headerTaka: Number(headerTaka || 0),
                    greyMtrs: Number(greyMtrs || 0),
                    location: location || ""
                };
            })
            .filter(Boolean);

        console.log("kaushal", selectedTakaRows);


        // ==========================================
        // IMPORTANT:
        // EK BHI TAKA SELECT NAHI HAI
        // TO ALLOCATION NAHI HOGI
        // ==========================================

        if (selectedTakaRows.length === 0) {
            toast.warning("Please select at least one Taka");
            return;
        }

        // ==========================================
        // QUANTITY
        // ==========================================

        const issueTaka = selectedTakaRows.length;

        const issueMeter = selectedTakaRows.reduce((total, row) => {
            const meterValue = issueMeterValues?.[row.rowId];

            return total + Number(meterValue || 0);
        }, 0);

        console.log("Selected Taka Rows:", selectedTakaRows);
        console.log("Issue Taka:", issueTaka);
        console.log("Issue Meter:", issueMeter);

        // ==========================================
        // CURRENT LOT -> ALLOCATED OBJECT
        // ==========================================

        const allocatedLot = {

            // ==========================================
            // LOT IDENTIFICATION
            // ==========================================
            id: String(currentLot.InwCode),
            InwCode: String(currentLot.InwCode),

            source: "insert",
            isAllocatedByAll: false,

            // ==========================================
            // TAKA DETAIL HEADER DATA
            // ==========================================
            shortStage: Number(shortStage || 0),
            headerTaka: Number(headerTaka || 0),
            greyMtrs: Number(greyMtrs || 0),
            location: location || "",

            // ==========================================
            // TAKA / DETAIL LEVEL
            // ==========================================

            TransDtlID:
                currentLot?.TransDtlID ??
                currentLot?.DetailCode ??
                null,

            ToSubStageID:
                currentLot?.ToSubStageID ??
                currentLot?.ToStageID ??
                null,

            lotNo: currentLot.LotNo,
            LotNo: currentLot.LotNo,

            inwDate: currentLot.InwDate,
            inwSrNo: currentLot.inwSrNo,

            acName: currentLot.AcName,
            pty: currentLot.ShortACName,

            groupName: currentLot.GroupName,
            quality: currentLot.QualityType,

            issueTaka: issueTaka,

            issueMeter: issueMeter,



            // ==========================================
            // SELECTED TAKA
            // ==========================================
            selectedTakas: selectedTakaRows.map(row => {
                const { shortMeter, ShortMeter, ...rest } = row;

                return {
                    ...rest,
                    issueMeter: Number(row?.issueMeter ?? 0).toFixed(2),
                    short: Number(shortMeter ?? 0).toFixed(2),
                    Short: Number(shortMeter ?? 0).toFixed(2)
                };
            }),

            _Operator: operatorVal,
            _Shift: shiftVal,
            _InTime: inTime,
            _OutTime: outTime,
            _AvgWeight: avgWeight,
            _Weight: weight,
        };

        console.log("Allocated Lot:", allocatedLot);

        // ==========================================
        // ALLOCATED GRID
        // OLD RECORDS KO REMOVE MAT KARO
        // NEW RECORD KO END ME ADD KARO
        // ==========================================
        setSelected((prev) => {
            const isEditing = Boolean(editingAllocatedLot);

            if (isEditing) {
                return prev.map((lot) =>
                    String(lot?.InwCode) === String(allocatedLot?.InwCode)
                        ? {
                            ...lot,
                            ...allocatedLot,
                            source: "update",

                            // Modal se jo Taka select hue hain
                            // wahi final list mein save honge
                            selectedTakas: allocatedLot.selectedTakas,
                        }
                        : lot
                );
            }

            // New allocation
            return [...prev, allocatedLot];
        });



        // ==========================================
        // AVAILABLE TABLE (ISHelpModal) SE REMOVE
        // ==========================================

        setISHelpModal(prev => {
            const list = Array.isArray(prev)
                ? prev
                : prev?.LotPendHelp || [];

            return list.filter(
                item =>
                    String(item?.InwCode) !==
                    String(currentLot.InwCode)
            );
        });

        // ==========================================
        // CHECKBOX BHI REMOVE
        // ==========================================

        setCheckedAvailable(prev => {
            const updated = { ...prev };

            delete updated[String(currentLot.InwCode)];

            return updated;
        });

        // ==========================================
        // MODAL CLOSE
        // ==========================================

        setIsTakaDetailOpen(false);

        // ==========================================
        // NEXT LOT
        // ==========================================

        const nextIndex = takaDetailIndex + 1;

        if (nextIndex < takaDetailQueue.length) {

            setTakaDetailIndex(nextIndex);

            // Previous Taka selection clear
            setSelectedTakas({});
            setTakaSearch("");
            setTakaQty("");

            const nextLotId = takaDetailQueue[nextIndex];

            console.log("Next Lot InwCode:", nextLotId);

            setTimeout(() => {
                openTakaDetailForLot(nextLotId);
            }, 200);

        } else {

            // ==========================================
            // ALL LOTS COMPLETE
            // ==========================================

            setTakaDetailQueue([]);
            setTakaDetailIndex(0);
            setSelectedAvailableLot(null);
            setEditingAllocatedLot(null);
            setSelectedTakas({});

            toast.success(
                "All selected lots allocated successfully"
            );
        }
    };

    const handleTakaDetailClose = async () => {
        // Current index
        const currentIndex = takaDetailIndex;

        // Next index
        const nextIndex = currentIndex + 1;

        console.log("Close Current Taka Detail");
        console.log("Current Index:", currentIndex);
        console.log("Next Index:", nextIndex);
        console.log("Queue:", takaDetailQueue);

        // Current Taka ka data clear karo
        setSelectedTakas({});
        setTakaSearch("");
        setTakaQty("");

        setDetails([]);
        setSubMianDetails([]);

        // ==========================================
        // NEXT LOT AVAILABLE HAI
        // ==========================================
        if (nextIndex < takaDetailQueue.length) {

            // Next index set
            setTakaDetailIndex(nextIndex);

            // Next lot ID
            const nextLotId = takaDetailQueue[nextIndex];

            console.log("Next Lot ID:", nextLotId);

            // Current modal temporarily close
            setIsTakaDetailOpen(false);

            // Thoda wait karke next API call
            setTimeout(async () => {
                await openTakaDetailForLot(nextLotId);
            }, 150);

            return;
        }

        // ==========================================
        // LAST LOT CLOSE
        // ==========================================
        setTakaDetailQueue([]);
        setTakaDetailIndex(0);
        setSelectedAvailableLot(null);

        // Taka Detail close hone ke baad
        // Available Lot ke saare checked records clear karo
        setCheckedAvailable({});

        // Taka selection bhi clear
        setSelectedTakas({});
        setTakaSearch("");
        setTakaQty("");

        setDetails([]);
        setSubMianDetails([]);

        setIsTakaDetailOpen(false);

        toast.info("Taka Detail closed");
    };

    const handleShowAllocatedDetail = async () => {

        // =====================================================
        // 1. Allocated me selected checkbox
        // =====================================================
        const checkedIds = Object.keys(checkedSelected).filter(
            id => checkedSelected[id]
        );

        console.log("1. checkedIds:", checkedIds);
        console.log("2. selected:", selected);

        if (checkedIds.length === 0) {
            toast.warning("Please select an allocated lot");
            return;
        }

        // =====================================================
        // 2. Selected allocated record
        // =====================================================
        const selectedLot = selected.find(
            item =>
                String(item?.InwCode) ===
                String(checkedIds[0])
        );

        console.log("3. selectedLot:", selectedLot);

        if (!selectedLot) {
            toast.warning("Selected allocated lot not found");
            return;
        }

        // =====================================================
        // 3. Selected allocated lot save
        // =====================================================
        setEditingAllocatedLot(selectedLot);

        // =====================================================
        // 4. UPDATE RECORD
        // =====================================================
        if (selectedLot?.source === "update") {

            console.log(
                "UPDATE SHOW DETAIL - InwCode:",
                selectedLot?.InwCode
            );

            // ---------------------------------------------
            // API se aaye hue SubDetail
            // ---------------------------------------------
            const subDetails = Array.isArray(transactionData?.SubDetail)
                ? transactionData.SubDetail
                : [];
            // ---------------------------------------------
            // Selected Allocated Lot ka InwCode
            // ---------------------------------------------
            const selectedInwCode = String(
                selectedLot?.InwCode ?? ""
            );

            // ---------------------------------------------
            // InwCode match
            // ---------------------------------------------
            const matchedSubDetails = subDetails.filter((detail) => {
                const inwardId =
                    detail?.InwCode ??
                    detail?.InwardID ??
                    detail?.InwardId;

                return String(inwardId ?? "") === selectedInwCode;
            });

            console.log("Selected InwCode:", selectedInwCode);
            console.log("All SubDetail:", subDetails);
            console.log("Matched SubDetail:", matchedSubDetails);

            setSubMianDetails(matchedSubDetails);




            // ---------------------------------------------
            // Details bhi InwCode se match
            // Agar Details me InwCode available hai
            // ---------------------------------------------
            const detailData = Array.isArray(transactionData?.Detail)
                ? transactionData.Detail
                : [];

            const matchedDetails = detailData.filter(
                detail =>
                    String(detail?.InwCode ?? "") ===
                    selectedInwCode
            );

            setDetails(matchedDetails);

            // ---------------------------------------------
            // Selected lot modal ko batao
            // ---------------------------------------------

            setSelectedAvailableLot(selectedLot);

            // ---------------------------------------------
            // Existing Taka selection restore
            // ---------------------------------------------

            const restoredSelected = {};
            const restoredMeters = {};

            const savedTakas = Array.isArray(selectedLot?.selectedTakas)
                ? selectedLot.selectedTakas
                : [];

            // Agar is lot ki selection pehle edit karke save ki gayi hai,
            // to wahi selection restore karo.
            if (savedTakas.some((taka) => taka?.rowId != null)) {
                savedTakas.forEach((taka) => {
                    const rowId = String(taka.rowId);

                    restoredSelected[rowId] = true;
                    restoredMeters[rowId] = Number(
                        taka?.issueMeter ?? taka?.Qty ?? 0
                    ).toFixed(2);
                });
            } else {
                // Pehli baar Update ka Show Detail khul raha hai:
                // saare existing Taka selected rakho.
                matchedSubDetails.forEach((row, index) => {
                    const rowId = `${row?.TransDtlID ?? "row"}_${index}`;

                    restoredSelected[rowId] = true;
                    restoredMeters[rowId] = Number(
                        row?.Qty ?? row?.BalMeter ?? 0
                    ).toFixed(2);
                });
            }

            setSelectedTakas(restoredSelected);
            setInitialIssueMeterValues(restoredMeters);
            setTakaQty(String(Object.keys(restoredSelected).length));
            setIsTakaDetailOpen(true);

            return;
        }

        // =====================================================
        // 5. INSERT RECORD
        // =====================================================

        console.log(
            "INSERT RECORD - API call karni hai"
        );

        await openTakaDetailForLot(
            selectedLot?.InwCode,
            selectedLot
        );
    };

    const handleAllocateAll = async () => {

        const checkedIds = Object.keys(checkedAvailable).filter(
            id => checkedAvailable[id]
        );

        if (checkedIds.length === 0) {
            toast.warning(" Please select available lots ");
            return;
        }

        const helpLots = Array.isArray(ISHelpModal)
            ? ISHelpModal
            : ISHelpModal?.LotPendHelp || [];

        const selectedLots = helpLots.filter(lot =>
            checkedIds.includes(String(lot?.InwCode))
        );

        if (selectedLots.length === 0) {
            toast.warning("Selected available lots not found");
            return;
        }

        console.log("kl;jjk", selectedLots);


        try {

            setIsLoading(true);

            const newAllocatedLots = [];

            // =====================================================
            // HAR SELECTED LOT
            // =====================================================

            for (const lot of selectedLots) {

                // =================================================
                // TAKA DETAIL API
                // =================================================

                const payload = {
                    FirmID: FirmID,

                    TransDtlID: String(
                        lot?.DetailCode ??
                        lot?.TransDtlID ??
                        ""
                    ),

                    InwCode: String(
                        lot?.InwCode ?? ""
                    ),

                    FromStageID: fromStageId,

                    FromSubStageID: fromSubStageId,

                    ToSubStageID: String(
                        lot?.ToSubStageID ??
                        lot?.ToStageID ??
                        ""
                    ),

                    TransTypeID: gateTxnId,
                };

                console.log(
                    "ALL TAKA DETAIL PAYLOAD:",
                    payload
                );

                const response = await dispatch(
                    TransSubDtlInsertHelp(payload)
                ).unwrap();

                const takaSubDetails =
                    Array.isArray(response?.TakaSubDtl)
                        ? response.TakaSubDtl
                        : [];

                console.log(
                    "ALL TAKA DETAILS:",
                    takaSubDetails
                );


                // =================================================
                // ALL TAKA SELECT
                // =================================================


                const selectedTakaRows =
                    takaSubDetails.map((row, index) => {

                        const rowId =
                            `${row?.TransDtlID ?? "row"}_${index} `;

                        const balanceMeter =
                            Number(row?.BalMeter ?? 0);

                        const takaIssueMeter = balanceMeter;

                        // Short Meter = Balance Meter - Issue Meter
                        const shortMeter = Math.max(
                            balanceMeter - takaIssueMeter,
                            0
                        );

                        return {
                            ...row,
                            rowId,

                            // Issue Meter
                            issueMeter: takaIssueMeter.toFixed(2),

                            ShortMeter: shortMeter.toFixed(2),
                        };
                    });


                console.log(
                    "ALL SELECTED TAKA ROWS:",
                    selectedTakaRows
                );


                // =================================================
                // ISSUE TAKA
                // =================================================

                const issueTaka =
                    selectedTakaRows.length;


                // =================================================
                // ISSUE METER SUM
                // =================================================

                const issueMeter =
                    selectedTakaRows.reduce(
                        (total, row) => {

                            return (
                                total +
                                Number(
                                    row?.issueMeter || 0
                                )
                            );

                        },
                        0
                    );


                console.log(
                    "ALL ISSUE TAKA:",
                    issueTaka
                );

                console.log(
                    "ALL ISSUE METER SUM:",
                    issueMeter
                );




                // =================================================
                // ALLOCATED LOT
                // =================================================

                const allocatedLot = {

                    ...lot,

                    id: String(
                        lot?.InwCode ?? ""
                    ),

                    InwCode: String(
                        lot?.InwCode ?? ""
                    ),

                    source: "insert",

                    // IMPORTANT
                    isAllocatedByAll: true,

                    TransDtlID: lot?.TransDtlID ?? 0,

                    DetailCode:
                        lot?.DetailCode ??
                        lot?.TransDtlID ??
                        "",

                    ToSubStageID:
                        lot?.ToSubStageID ??
                        lot?.ToStageID ??
                        null,

                    lotNo:
                        lot?.LotNo ??
                        lot?.lotNo ??
                        "",

                    LotNo:
                        lot?.LotNo ??
                        lot?.lotNo ??
                        "",

                    inwDate:
                        lot?.InwDate ??
                        lot?.inwDate ??
                        "",

                    inwSrNo:
                        lot?.InwSrNo ??
                        lot?.inwSrNo ??
                        "",

                    acName:
                        lot?.AcName ??
                        lot?.acName ??
                        "",

                    pty:
                        lot?.ShortACName ??
                        lot?.pty ??
                        "",

                    groupName:
                        lot?.GroupName ??
                        lot?.groupName ??
                        "",

                    quality:
                        lot?.QualityType ??
                        lot?.quality ??
                        "",


                    // =============================================
                    // TOTAL TAKA
                    // =============================================

                    issueTaka:
                        issueTaka,


                    // =============================================
                    // TOTAL ISSUE METER
                    // =============================================

                    issueMeter:
                        issueMeter,


                    // =============================================
                    // ALL TAKA DETAILS
                    // =============================================

                    selectedTakas:
                        selectedTakaRows,


                    _Operator: operatorVal,
                    _Shift: shiftVal,
                    _InTime: inTime,
                    _OutTime: outTime,
                    _AvgWeight: avgWeight,
                    _Weight: weight,
                };


                console.log(
                    "FINAL ALL ALLOCATED LOT:",
                    allocatedLot
                );


                newAllocatedLots.push(
                    allocatedLot
                );


            }

            // =====================================================
            // ALLOCATED GRID
            // =====================================================

            setSelected(prevSelected => [

                ...prevSelected,

                ...newAllocatedLots.filter(
                    newLot =>
                        !prevSelected.some(
                            oldLot =>
                                String(
                                    oldLot?.InwCode
                                ) ===
                                String(
                                    newLot?.InwCode
                                )
                        )
                )

            ]);


            // ==============================================
            // 

            // =====================================================
            // AVAILABLE SE REMOVE
            // =====================================================

            setAvailable(prevAvailable =>
                prevAvailable.filter(
                    lot =>
                        !checkedIds.includes(
                            String(lot?.InwCode)
                        )
                )
            );

            // =====================================================
            // ISHelpModal SE REMOVE
            // =====================================================

            setISHelpModal(prev => {

                const current =
                    Array.isArray(prev)
                        ? prev
                        : prev?.LotPendHelp || [];

                return current.filter(
                    lot =>
                        !checkedIds.includes(
                            String(lot?.InwCode)
                        )
                );
            });


            // =====================================================
            // CHECKED CLEAR
            // =====================================================

            setCheckedAvailable({});


            toast.success(
                "All Taka allocated successfully"
            );

        } catch (error) {

            console.error(
                "ALL Allocation Error:",
                error
            );

            toast.error(
                error?.message ||
                "Failed to allocate all Taka"
            );

        } finally {

            setIsLoading(false);

        }
    };

    // Perform quick allocation using full values
    const handleAllocateAsIs = () => {
        const checkedIds = Object.keys(checkedAvailable).filter(id => checkedAvailable[id]);
        const toAlloc = checkedIds.map(id => {
            const lot = available.find(a => a.id === id);
            return {
                id: lot.id,
                lotNo: lot.lotNo,
                inwDate: lot.inwDate,
                inwSrNo: lot.inwSrNo,
                acName: lot.acName,
                pty: lot.pty,
                groupName: lot.groupName,
                quality: lot.quality,
                issueTaka: lot.taka,
                issueMeter: lot.meter
            };
        });

        setSelected([...selected, ...toAlloc]);

        const newAvailable = available.filter(a => !checkedAvailable[a.id]);
        setAvailable(newAvailable);
        setCheckedAvailable({});
        setIsAllocationModalOpen(false);
        toast.success("Full lot allocation completed");
    };

    // Handle Edit Input in Allocation modal
    const handleModalFieldEdit = (id, field, value) => {
        const val = Number(value);
        const updated = lotsToAllocate.map(lot => {
            if (lot.id === id) {
                const lotUpdate = { ...lot, [field]: value };
                const errs = { ...allocationErrors };
                if (isNaN(val) || val <= 0) {
                    errs[id] = { ...errs[id], [field]: "Must be a positive number" };
                } else if (field === "editTaka" && val > lot.origTaka) {
                    errs[id] = { ...errs[id], editTaka: `Max: ${lot.origTaka} Taka` };
                } else if (field === "editMeter" && val > lot.origMeter) {
                    errs[id] = { ...errs[id], editMeter: `Max: ${lot.origMeter} Meter` };
                } else {
                    if (errs[id]) {
                        delete errs[id][field];
                        if (Object.keys(errs[id]).length === 0) delete errs[id];
                    }
                }
                setAllocationErrors(errs);
                return lotUpdate;
            }
            return lot;
        });
        setLotsToAllocate(updated);
    };

    // Finalize Custom Allocation from Modal
    const handleAllocateEdited = () => {
        if (Object.keys(allocationErrors).length > 0) {
            toast.error("Please resolve validation errors before allocating");
            return;
        }

        const newSelected = [...selected];
        const newAvailable = [...available];

        lotsToAllocate.forEach(alloc => {
            const issueTaka = Number(alloc.editTaka);
            const issueMeter = Number(alloc.editMeter);

            const existingSelIdx = newSelected.findIndex(s => s.id === alloc.id);
            if (existingSelIdx !== -1) {
                newSelected[existingSelIdx].issueTaka += issueTaka;
                newSelected[existingSelIdx].issueMeter += issueMeter;
            } else {
                newSelected.push({
                    id: alloc.id,
                    lotNo: alloc.lotNo,
                    inwDate: alloc.inwDate,
                    inwSrNo: alloc.inwSrNo,
                    acName: alloc.acName,
                    pty: alloc.pty,
                    groupName: alloc.groupName,
                    quality: alloc.quality,
                    issueTaka,
                    issueMeter
                });
            }

            const availIdx = newAvailable.findIndex(a => a.id === alloc.id);
            if (availIdx !== -1) {
                newAvailable[availIdx].taka -= issueTaka;
                newAvailable[availIdx].meter -= issueMeter;
            }

        });


        const filteredAvailable = newAvailable.filter(a => a.taka > 0 || a.meter > 0);


        setAvailable(filteredAvailable);
        setSelected(newSelected);
        setCheckedAvailable({});
        setIsAllocationModalOpen(false);
        toast.success(" Custom lot allocation completed ");
    };

    // ==========================================
    // MOVE LEFT
    // Allocated -> Available
    // ==========================================
    // const moveSelectedLeft = () => {


    //     const checkedIds = Object.keys(checkedSelected).filter(
    //         id => checkedSelected[id]
    //     );

    //     if (checkedIds.length === 0) {
    //         toast.warning("Please select an allocated lot to return");
    //         return;
    //     }

    //     const returningLots = selected.filter(item =>
    //         checkedIds.includes(String(item?.InwCode))
    //     );

    //     if (returningLots.length === 0) {
    //         toast.warning("Selected allocated lot not found");
    //         return;
    //     }

    //     // =====================================================
    //     // ORIGINAL AVAILABLE DATA SE EXACT RECORD LO
    //     // =====================================================
    //     setISHelpModal(prev => {
    //         const current = Array.isArray(prev)
    //             ? prev
    //             : prev?.LotPendHelp || [];

    //         const updated = [...current];

    //         returningLots.forEach(allocatedItem => {

    //             const inwCode = String(allocatedItem?.InwCode);

    //             // Original Available Lot me search
    //             const originalRecord = originalAvailableLots.find(
    //                 availableItem =>
    //                     String(availableItem?.InwCode) === inwCode
    //             );

    //             if (!originalRecord) {
    //                 return;
    //             }

    //             // Already available hai to duplicate mat karo
    //             const alreadyExists = updated.some(
    //                 item =>
    //                     String(item?.InwCode) === inwCode
    //             );

    //             if (!alreadyExists) {
    //                 // EXACT ORIGINAL RECORD
    //                 updated.push({
    //                     ...originalRecord
    //                 });
    //             }
    //         });

    //         return updated;
    //     });

    //     // Allocated se remove
    //     setSelected(prevSelected =>
    //         prevSelected.filter(
    //             item =>
    //                 !checkedIds.includes(
    //                     String(item?.InwCode)
    //                 )
    //         )
    //     );

    //     setCheckedSelected({});

    //     toast.success("Lot returned to Available Lots");
    // };

    // ==========================================
    // MOVE LEFT
    // Allocated -> Available
    // ==========================================
    const moveSelectedLeft = () => {
        const checkedIds = Object.keys(checkedSelected).filter(
            (id) => checkedSelected[id]
        );

        if (checkedIds.length === 0) {
            toast.warning("Please select an allocated lot to return");
            return;
        }

        // ==========================================
        // 1. FORWARD DETAIL KE SAARE SUBDETAIL IDs
        // ==========================================
        const forwardDtl = TransDeleteCheckdata?.ForwrdDtl;

        const forwardRows = Array.isArray(forwardDtl)
            ? forwardDtl
            : forwardDtl
                ? [forwardDtl]
                : [];

        const forwardSubDtlIds = new Set(
            forwardRows
                .map((item) => item?.TransSubDtlID)
                .filter(
                    (id) =>
                        id !== null &&
                        id !== undefined &&
                        String(id).trim() !== ""
                )
                .map((id) => String(id))
        );

        // ==========================================
        // 2. SELECTED ALLOCATED LOTS
        // ==========================================
        const returningLots = selected.filter((lot) =>
            checkedIds.includes(String(lot?.InwCode))
        );

        if (returningLots.length === 0) {
            toast.warning("Selected allocated lot not found");
            return;
        }

        // ==========================================
        // 3. HAR LOT KE SAARE SELECTED TAKAS CHECK KARO
        // TransSubDtlID match ho to lot protected rahega
        // ==========================================
        const blockedLots = [];
        const allowedLots = [];

        returningLots.forEach((lot) => {
            const lotTakas = Array.isArray(lot?.selectedTakas)
                ? lot.selectedTakas
                : [];

            const hasForwardMatch = lotTakas.some((taka) => {
                const subDtlId = taka?.TransSubDtlID;

                return (
                    subDtlId !== null &&
                    subDtlId !== undefined &&
                    forwardSubDtlIds.has(String(subDtlId))
                );
            });

            if (hasForwardMatch) {
                blockedLots.push(lot);
            } else {
                allowedLots.push(lot);
            }
        });

        // ==========================================
        // 4. MATCH HONE WALA LOT AVAILABLE ME NAHI JAYEGA
        // ==========================================
        if (blockedLots.length > 0) {
            toast.warning(
                `${blockedLots.length} allocated lot(s) cannot be returned because forward details exist.`
            );
        }

        // Koi bhi allowed lot nahi hai to kuch remove mat karo
        if (allowedLots.length === 0) {
            setCheckedSelected({});
            return;
        }

        // ==========================================
        // 5. SIRF ALLOWED LOTS AVAILABLE ME ADD KARO
        // ==========================================
        setISHelpModal((prev) => {
            const current = Array.isArray(prev)
                ? prev
                : prev?.LotPendHelp || [];

            const updated = [...current];

            allowedLots.forEach((allocatedItem) => {
                const inwCode = String(allocatedItem?.InwCode);

                const originalRecord = originalAvailableLots.find(
                    (availableItem) =>
                        String(availableItem?.InwCode) === inwCode
                );

                if (!originalRecord) return;

                const alreadyExists = updated.some(
                    (item) => String(item?.InwCode) === inwCode
                );

                if (!alreadyExists) {
                    updated.push({ ...originalRecord });
                }
            });

            return updated;
        });

        // ==========================================
        // 6. ALLOCATED SE SIRF ALLOWED LOTS REMOVE KARO
        // BLOCKED LOTS ALLOCATED ME HI RAHENGE
        // ==========================================
        const allowedInwCodes = new Set(
            allowedLots.map((lot) => String(lot?.InwCode))
        );

        setSelected((prevSelected) =>
            prevSelected.filter(
                (lot) => !allowedInwCodes.has(String(lot?.InwCode))
            )
        );

        setCheckedSelected({});
    };

    // Handle inline edit in the allocated lots table
    const handleInlineSelectedEdit = (id, field, value) => {
        const val = Number(value);
        if (isNaN(val) || val < 0) return;

        const origLot = INITIAL_AVAILABLE.find(o => o.id === id);
        if (!origLot) return;

        const maxVal = field === "issueTaka" ? origLot.taka : origLot.meter;
        if (val > maxVal) {
            toast.warning(`Cannot exceed original available quantity (${maxVal})`);
            return;
        }

        setSelected(selected.map(item => {
            if (item.id === id) {
                return { ...item, [field]: val };
            }
            return item;
        }));

        const allocatedTaka = field === "issueTaka" ? val : (selected.find(s => s.id === id)?.issueTaka || 0);
        const allocatedMeter = field === "issueMeter" ? val : (selected.find(s => s.id === id)?.issueMeter || 0);

        setAvailable(INITIAL_AVAILABLE.map(item => {
            if (item.id === id) {
                return {
                    ...item,
                    taka: origLot.taka - allocatedTaka,
                    meter: origLot.meter - allocatedMeter
                };
            }
            const matchedSelected = selected.find(s => s.id === item.id);
            if (matchedSelected) {
                return {
                    ...item,
                    taka: item.taka - matchedSelected.issueTaka,
                    meter: item.meter - matchedSelected.issueMeter
                };
            }
            return item;
        }).filter(item => item.taka > 0 || item.meter > 0));
    };

    // Check/Uncheck selectors available
    const handleSelectAllAvailable = (ids, checked) => {
        setCheckedAvailable((prev) => {
            const updated = { ...prev };

            ids.forEach((id) => {
                if (checked) {
                    updated[id] = true;
                } else {
                    delete updated[id];
                }
            });

            return updated;
        });
    };

    // Available Roll Lots -> SINGLE SELECT
    const handleSelectAvailableRow = (id, checked) => {
        setCheckedAvailable((prev) => {
            const updated = { ...prev };

            if (checked) {
                // Multiple records select honge
                updated[id] = true;
            } else {
                // Sirf current record deselect hoga
                delete updated[id];
            }

            return updated;
        });
    };

    // Header → Select All / Deselect All
    const handleSelectAllSelected = (e) => {
        const checked = e.target.checked;

        const tracker = {};

        if (checked) {
            filteredSelected.forEach((item) => {
                const id = item?.TransDtlID ?? item?.id;

                if (id != null) {
                    tracker[id] = true;
                }
            });
        }

        setCheckedSelected(tracker);

    };


    // ==========================================
    // ALLOCATED ROW MULTI SELECT
    // ==========================================

    const handleSelectSelectedRow = (id, checked) => {
        if (checked) {
            setCheckedSelected({
                [id]: true
            });
        } else {
            setCheckedSelected({});
        }
    };

    // Table theme colors
    const tableBg = isdark === "light" ? iscolour?.Colour1 || "#ffffff" : iscolourDark?.Colour9 || "#2d1f0f";
    const tableHeaderBg = isdark === "light" ? iscolour?.Colour8 || "#D78C4D" : iscolourDark?.Colour7 || "#7a5637";
    const tableBorder = isdark === "light" ? iscolour?.Colour6 || "#e6a571" : iscolourDark?.Colour8 || "#6b4423";
    const tableText = isdark === "light" ? iscolour?.Colour11 || "#8b5a2b" : iscolourDark?.Colour1 || "#fcefd9";

    // Dynamic checked row background tint
    const getCheckedRowBg = (isChecked, isSelectedTable = false) => {
        if (!isChecked) return tableBg;
        const hex = btnBg || "#fb923c";
        const cleanHex = hex.replace("#", "");
        const num = parseInt(cleanHex, 16);
        const r = (num >> 16) & 255;
        const g = (num >> 8) & 255;
        const b = num & 255;

        if (isdark === "light") {
            return isSelectedTable
                ? `rgba(239, 68, 68, 0.12)`
                : `rgba(${r}, ${g}, ${b}, 0.12)`;
        } else {
            return isSelectedTable
                ? `rgba(239, 68, 68, 0.2)`
                : `rgba(${r}, ${g}, ${b}, 0.2)`;
        }
    };

    const themeColors = {
        bgTheme,
        textTheme,
        borderTheme,
        bgCard,
        btnBg,
        btnText,
        headingCol,
        accentCol,
        inputBg,
        hoverBg,
        tableBg,
        tableHeaderBg,
        tableBorder,
        tableText,
        iscolour,
        iscolourDark,
        isdark
    };

    return (
        <div
            style={{
                background: bgTheme,
                minHeight: "100vh",
                padding: "20px",
                color: textTheme
            }}
            className="theme-scroll"
        >
            {/* Full Page Theme Loader */}
            {isLoading && (
                <div className="full-page-loader">
                    <div className="text-center">
                        <div className="theme-spinner mb-3" style={{ margin: "0 auto" }}></div>
                        <div className="theme-loader-text">SYNCING WITH MILLSTAGE DATABASE...</div>
                    </div>
                </div>
            )}
            <style>
                {`
            /* ── Page wrapper ── */
            .theme-scroll { font-family: 'Inter', 'Segoe UI', sans-serif; }

            /* ── Workspace table ── */
            .custom-workspace-table.table {
                border-collapse: collapse !important;
                border: none !important;
                width: 100%;
                background-color: ${tableBg} !important;
            }
            .custom-workspace-table.table th,
            .custom-workspace-table.table td {
                border: 1px solid ${tableBorder} !important;
                vertical-align: middle !important;
            }
            .custom-workspace-table.table > :not(caption) > * > * {
                background-color: ${tableBg} !important;
                color: ${tableText} !important;
                border: 1px solid ${tableBorder} !important;
                transition: background-color 0.2s ease;
            }
            .custom-workspace-table.table > thead > tr > th {
                background: linear-gradient(135deg,
                ${tableHeaderBg} 0%,
                ${isdark === "light" ? iscolour?.Colour9 || "#a66b35" : iscolourDark?.Colour6 || "#8b5a2b"} 100%
                ) !important;
                color: #fff !important;
                font-weight: 700 !important;
                letter-spacing: 0.5px;
                text-transform: uppercase;
                font-size: 12px;
                padding: 11px 13px !important;
                border-right: 1px solid ${isdark === "light" ? iscolour?.Colour9 || "#a66b35" : iscolourDark?.Colour8 || "#6b4423"} !important;
            }
            .custom-workspace-table.table > tbody > tr:nth-of-type(odd) > td {
                background-color: ${isdark === "light" ? iscolour?.Colour4 || "#fef3e8" : iscolourDark?.Colour9 || "#2d1f0f"} !important;
            }
            .custom-workspace-table.table > tbody > tr:nth-of-type(even) > td {
                background-color: ${isdark === "light" ? iscolour?.Colour1 || "#fff" : iscolourDark?.Colour10 || "#1a1208"} !important;
            }
            .custom-workspace-table.table > tbody > tr:hover > td {
                background-color: ${isdark === "light" ? iscolour?.Colour5 || "#fde9d3" : iscolourDark?.Colour7 || "#7a5637"} !important;
            }

            /* ── Quantity input ── */
            .modal-quantity-input {
                width: 100%; padding: 6px 10px; border-radius: 8px;
                border: 1px solid ${isdark === "light" ? iscolour?.Colour6 || "#e6a571" : iscolourDark?.Colour7 || "#7a5637"} !important;
                text-align: center;
                background-color: ${isdark === "light" ? iscolour?.Colour4 || "#fef3e8" : iscolourDark?.Colour9 || "#2d1f0f"} !important;
                color: ${tableText} !important;
                transition: all 0.2s ease; outline: none;
            }
            .modal-quantity-input:focus {
                border-color: ${btnBg} !important;
                box-shadow: 0 0 0 3px ${btnBg}44 !important;
            }

            /* ── Search inputs ── */
            .workspace-search-input {
                background: ${isdark === "light" ? iscolour?.Colour3 || "#faf8f5" : iscolourDark?.Colour8 || "#6b4423"} !important;
                border: 1px solid ${isdark === "light" ? iscolour?.Colour6 || "#e6a571" : iscolourDark?.Colour7 || "#7a5637"} !important;
                color: ${tableText} !important;
            }
            .workspace-search-input::placeholder {
                color: ${isdark === "light" ? iscolour?.Colour7 || "#d7b08a" : iscolourDark?.Colour5 || "#b07540"} !important;
            }
            .workspace-search-input:focus {
                border-color: ${btnBg} !important;
                box-shadow: 0 0 0 3px ${btnBg}44 !important;
                background-color: ${isdark === "light" ? iscolour?.Colour4 || "#fef3e8" : iscolourDark?.Colour9 || "#2d1f0f"} !important;
            }

            /* ── Checkbox ── */
            .custom-checkbox {
                width: 18px !important; height: 18px !important;
                cursor: pointer;
                accent-color: ${btnBg} !important;
            }

            /* ── Scrollbar ── */
            .custom-workspace-scroll::-webkit-scrollbar { width: 5px; height: 5px; }
            .custom-workspace-scroll::-webkit-scrollbar-track {
                background: ${isdark === "light" ? iscolour?.Colour3 || "#faf8f5" : iscolourDark?.Colour10 || "#1a1208"} !important;
            }
            .custom-workspace-scroll::-webkit-scrollbar-thumb {
                background: ${isdark === "light" ? iscolour?.Colour7 || "#d7b08a" : iscolourDark?.Colour6 || "#8b5a2b"} !important;
                border-radius: 4px !important;
            }

            /* ── Hover card ── */
            .hover-card-glowing:hover {
                transform: translateY(-2px);
                border-color: ${btnBg} !important;
                box-shadow: 0 6px 24px ${btnBg}30 !important;
                background-color: ${isdark === "light" ? iscolour?.Colour4 || "#fef3e8" : iscolourDark?.Colour8 || "#6b4423"} !important;
                cursor: pointer;
            }

            /* ── Button hover ── */
            .hover-scale-btn:hover {
                transform: scale(1.04);
                opacity: 0.92;
            }

            /* ── Badge pills in workspace ── */
            .ws-pill-badge {
                background: ${isdark === "light" ? iscolour?.Colour5 || "#fde9d3" : iscolourDark?.Colour7 || "#7a5637"};
                color: ${isdark === "light" ? iscolour?.Colour9 || "#a66b35" : iscolourDark?.Colour1 || "#fcefd9"};
                border: 1px solid ${isdark === "light" ? iscolour?.Colour6 || "#e6a571" : iscolourDark?.Colour6 || "#8b5a2b"};
                border-radius: 20px; padding: 3px 10px;
                font-size: 12px; font-weight: 700;
            }

            /* ── Transfer Buttons ── */
            .trans-btn-right {
                background: ${isdark === "light" ? iscolour?.Colour8 || "#D78C4D" : iscolourDark?.Colour4 || "#e19b5f"} !important;
                color: ${isdark === "light" ? "#fff" : iscolourDark?.Colour10 || "#1a1208"} !important;
                border: none !important;
                border-radius: 50% !important;
                width: 52px !important;
                height: 52px !important;
                box-shadow: 0 8px 22px ${isdark === "light" ? "rgba(215, 140, 77, 0.45)" : "rgba(225, 155, 95, 0.45)"} !important;
                display: flex !important;
                align-items: center !important;
                justify-content: center !important;
                transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
                cursor: pointer !important;
                outline: none !important;
            }
            .trans-btn-right:hover {
                transform: scale(1.1) translateY(-2px) !important;
                box-shadow: 0 12px 28px ${isdark === "light" ? "rgba(215, 140, 77, 0.65)" : "rgba(225, 155, 95, 0.65)"} !important;
            }
            .trans-btn-right:active {
                transform: scale(0.95) !important;
            }

            .trans-btn-left {
                background: ${isdark === "light" ? iscolour?.Colour3 || "#faf8f5" : "rgba(255, 255, 255, 0.05)"} !important;
                color: ${isdark === "light" ? iscolour?.Colour11 || "#8b5a2b" : iscolourDark?.Colour2 || "#f5c99f"} !important;
                border: 2px solid ${isdark === "light" ? iscolour?.Colour6 || "#e6a571" : iscolourDark?.Colour4 || "#e19b5f"} !important;
                border-radius: 50% !important;
                width: 52px !important;
                height: 52px !important;
                box-shadow: 0 6px 16px rgba(0,0,0,0.12) !important;
                display: flex !important;
                align-items: center !important;
                justify-content: center !important;
                transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
                cursor: pointer !important;
                outline: none !important;
            }
            .trans-btn-left:hover {
                transform: scale(1.1) translateY(-2px) !important;
                box-shadow: 0 10px 24px rgba(0,0,0,0.22) !important;
                border-color: ${isdark === "light" ? iscolour?.Colour8 || "#D78C4D" : iscolourDark?.Colour2 || "#f5c99f"} !important;
            }
            .trans-btn-left:active {
                transform: scale(0.95) !important;
            }

            /* ── Custom Theme Loader ── */
            .theme-spinner {
                width: 44px;
                height: 44px;
                border: 4px solid ${isdark === "light" ? iscolour?.Colour4 || "#fef3e8" : iscolourDark?.Colour9 || "#2d1f0f"};
                border-top: 4px solid ${isdark === "light" ? iscolour?.Colour8 || "#D78C4D" : iscolourDark?.Colour4 || "#e19b5f"};
                border-radius: 50%;
                animation: spin 0.85s linear infinite;
                box-shadow: 0 0 15px ${isdark === "light" ? iscolour?.Colour8 || "#D78C4D" : iscolourDark?.Colour4 || "#e19b5f"}30;
            }
            .theme-loader-text {
                font-size: 13.5px;
                font-weight: 800;
                color: ${isdark === "light" ? iscolour?.Colour10 || "#c46f20" : iscolourDark?.Colour2 || "#f5c99f"};
                letter-spacing: 0.5px;
                animation: pulse 1.5s ease-in-out infinite;
            }
            @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
            }
            @keyframes pulse {
                0%, 100% { opacity: 0.65; }
                50% { opacity: 1; }
            }

            /* ── Full Page Loader Overlay ── */
            .full-page-loader {
                position: fixed;
                top: 0; left: 0; right: 0; bottom: 0;
                background: ${isdark === "light" ? "rgba(250, 248, 245, 0.85)" : "rgba(26, 18, 8, 0.85)"};
                z-index: 9999;
                display: flex;
                align-items: center;
                justify-content: center;
                backdrop-filter: blur(4px);
            }

            /* ── Shared Modal Action Buttons ── */
            .td-btn {
                display: flex !important;
                align-items: center !important;
                gap: 8px !important;
                font-size: 13.5px !important;
                font-weight: 800 !important;
                padding: 8px 22px !important;
                border-radius: 8px !important;
                border: none !important;
                cursor: pointer !important;
                transition: all 0.2s ease !important;
            }
            .td-btn:hover {
                transform: translateY(-1.5px) !important;
                box-shadow: 0 6px 15px rgba(0,0,0,0.25) !important;
            }
            .td-btn-ok { background: #16a34a !important; color: #fff !important; }
            .td-btn-cancel { background: #dc2626 !important; color: #fff !important; }
            
            .td-close-btn {
                background: transparent !important;
                border: none !important;
                color: #fff !important;
                padding: 8px !important;
                border-radius: 50% !important;
                cursor: pointer !important;
                display: flex !important;
                align-items: center !important;
                justify-content: center !important;
                transition: all 0.2s ease !important;
            }
            .td-close-btn:hover {
                background: rgba(255,255,255,0.2) !important;
                transform: rotate(90deg) !important;
            }
            `}
            </style>

            {/* 1. SETUP GATE MODAL / OVERLAY */}
            {!isGatePassed && (
                <AccessGate
                    isGateLoading={isGateLoading}
                    gateStageVal={gateStageVal}
                    setGateStageVal={setGateStageVal}
                    gateStageId={gateStageId}
                    setGateStageId={setGateStageId}
                    gateTxnVal={gateTxnVal}
                    setGateTxnVal={setGateTxnVal}
                    gateTxnId={gateTxnId}
                    setGateTxnId={setGateTxnId}
                    handleGo={handleGo}
                    stagesList={StageList}
                    txnTypes={TransTypeList}
                    themeColors={themeColors}
                />
            )}

            {/* WORKSPACE CONTENT */}
            {isGatePassed && (
                <div>
                    {/* A. ACTIONS & FILTERS HEADER BAR */}
                    <div
                        style={{
                            background: bgCard,
                            borderRadius: "14px",
                            padding: "16px 20px",
                            border: `1px solid ${borderTheme}`,
                            marginBottom: "20px",
                            boxShadow: "0 4px 15px rgba(0,0,0,0.05)"
                        }}
                    >
                        <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
                            <div className="d-flex align-items-center gap-3">
                                <div
                                    style={{
                                        background: btnBg,
                                        color: "#fff",
                                        borderRadius: "8px",
                                        padding: "8px 12px",
                                        fontSize: "12px",
                                        fontWeight: "700",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px"
                                    }}
                                >
                                    <Layers size={14} />
                                    {gateStageVal} : {gateTxnVal}
                                </div>
                                <h5 style={{ margin: 0, fontWeight: "700", letterSpacing: "0.5px" }}>
                                    Lot Allocation Workspace
                                </h5>
                            </div>

                            {/* Quick Workspace Controls */}
                            <div className="d-flex align-items-center gap-2">
                                {!isAdding && !editingId ? (
                                    <button
                                        onClick={handleNew}
                                        style={{
                                            background: btnBg,
                                            color: btnText,
                                            border: "none",
                                            borderRadius: "10px",
                                            padding: "8px 16px",
                                            fontWeight: "600",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "6px"
                                        }}
                                        className="hover-scale-btn"
                                    >
                                        <Plus size={16} /> New Record
                                    </button>
                                ) : (
                                    <>

                                        <button
                                            onClick={handleInsert}
                                            style={{
                                                background: btnBg,
                                                color: btnText,
                                                border: "none",
                                                borderRadius: "10px",
                                                padding: "8px 16px",
                                                fontWeight: "600",
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "6px"
                                            }}
                                            className="hover-scale-btn"
                                        >
                                            <Save size={16} /> {editingId ? "Update" : "Save"}
                                        </button>
                                        <button
                                            onClick={resetForm}
                                            style={{
                                                background: "#ef4444",
                                                color: "#fff",
                                                border: "none",
                                                borderRadius: "10px",
                                                padding: "8px 16px",
                                                fontWeight: "600",
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "6px"
                                            }}
                                            className="hover-scale-btn"
                                        >
                                            <X size={16} /> Cancel
                                        </button>
                                    </>
                                )}

                            </div>
                        </div>
                    </div>

                    {/* B. TRANSACTION MASTER FORM & SIDEBAR PARAMETERS */}
                    {(isAdding || editingId) && (
                        <MasterForm
                            placeholderColor={isdark === "light" ? "#a8a8a8" : "#8f8f8f"}

                            txnDate={txnDate}
                            setTxnDate={setTxnDate}
                            srNo={srNo}
                            setSrNo={setSrNo}
                            fromStageVal={fromStageVal}
                            setFromStageVal={setFromStageVal}
                            fromStageId={fromStageId}
                            setFromStageId={setFromStageId}
                            toMachineVal={toMachineVal}
                            setToMachineVal={setToMachineVal}
                            toMachineId={toMachineId}
                            setToMachineId={setToMachineId}
                            fromSubStageVal={fromSubStageVal}
                            setFromSubStageVal={setFromSubStageVal}
                            fromSubStageId={fromSubStageId}
                            setFromSubStageId={setFromSubStageId}

                            processVal={processVal}
                            setProcessVal={setProcessVal}
                            processId={processId}
                            setProcessId={setProcessId}

                            treatmentVal={treatmentVal}
                            setTreatmentVal={setTreatmentVal}
                            treatmentId={treatmentId}
                            setTreatmentId={setTreatmentId}
                            processTypeVal={processTypeVal}
                            setProcessTypeVal={setProcessTypeVal}
                            processTypeId={processTypeId}
                            setProcessTypeId={setProcessTypeId}
                            recipeVal={recipeVal}
                            setRecipeVal={setRecipeVal}
                            recipeId={recipeId}
                            setRecipeId={setRecipeId}
                            shadeVal={shadeVal}
                            setShadeVal={setShadeVal}
                            shadeId={shadeId}
                            setShadeId={setShadeId}

                            machineVal={machineVal}
                            setMachineVal={setMachineVal}
                            machineId={machineId}
                            setMachineId={setMachineId}

                            transactionMasterVal={transactionMasterVal}
                            setTransactionMasterVal={setTransactionMasterVal}

                            transactionMasterId={transactionMasterId}
                            setTransactionMasterId={setTransactionMasterId}

                            processQualityVal={processQualityVal}
                            setProcessQualityVal={setProcessQualityVal}


                            processQualityId={processQualityId}
                            setProcessQualityId={setProcessQualityId}

                            remark={remark}
                            setRemark={setRemark}

                            // ==========================================
                            // Operational Parameters
                            // ==========================================

                            // _AvgWeight
                            avgWeight={avgWeight}
                            setAvgWeight={setAvgWeight}

                            // _BatchNo
                            batchNo={batchNo}
                            setBatchNo={setBatchNo}

                            // _ChartNo
                            chartNo={chartNo}
                            setChartNo={setChartNo}

                            // _InTime
                            inTime={inTime}
                            setInTime={setInTime}

                            // _Liquor
                            liquorVal={liquorVal}
                            setLiquorVal={setLiquorVal}

                            liquorId={liquorId}
                            setLiquorId={setLiquorId}

                            // _MILL
                            millVal={millVal}
                            setMillVal={setMillVal}

                            // _Operator
                            operatorVal={operatorVal}
                            setOperatorVal={setOperatorVal}

                            operatorId={operatorId}
                            setOperatorId={setOperatorId}

                            // _OutTime
                            outTime={outTime}
                            setOutTime={setOutTime}

                            // _PROG
                            progVal={progVal}
                            setProgVal={setProgVal}

                            // _PROGDATE
                            progDateVal={progDateVal}
                            setProgDateVal={setProgDateVal}

                            // _Shift
                            shiftVal={shiftVal}
                            setShiftVal={setShiftVal}

                            // _Weight
                            weight={weight}
                            setWeight={setWeight}

                            costShPercent={costShPercent}
                            setCostShPercent={setCostShPercent}

                            errors={errors}
                            setErrors={setErrors}

                            setIsHelpModalOpen={setIsHelpModalOpen}
                            HelpModel={helpmodelopen}
                            setIsStoppageModalOpen={setIsStoppageModalOpen}
                            setIsRecipeModalOpen={setIsRecipeModalOpen}

                            handleProcessFilter={handleProcessFilter}
                            handleRecipeChange={handleRecipeChange}
                            onTreatmentChange={handleTreatmentChange}
                            onOpenRecipeDetail={handleOpenRecipeDetail}
                            isRecipeDetailLoaded={isRecipeDetailLoaded}
                            setIsLotHelpOpen={setIsLotHelpOpen}
                            isLotHelpOpen={isLotHelpOpen}

                            stagesList={StageList1}
                            machinesList={ToStageList}
                            machinesList1={MatchingList}
                            subStagesList={FilteredSubStageList}
                            processList={ProcessMstList}
                            treatmentList={TreatmentList}
                            processTypeList={ProcessTypeList}
                            recipeList={RecipeList}
                            shadeList={ShadeList}
                            shiftsList={SHIFTS_LIST}
                            themeColors={themeColors}
                            processQualityList={ProcessQualityType}
                            TransactionMasterList={TransactionMasterList}
                            QualityType={QualityType}
                            PartyList={PartyList}
                            ProcessGrpList={ProcessGrpList}
                            QualityType2={QualityType2}

                        />
                    )}

                    {/* C. LOT ALLOCATION WORKSPACE (DUAL TABLES SPLIT) */}
                    {(isAdding || editingId) && (
                        <div
                            style={{
                                background: bgCard,
                                borderRadius: "14px",
                                padding: "20px",
                                border: `1px solid ${borderTheme}`,
                                boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
                                marginBottom: "24px"
                            }}
                        >
                            <div className="d-flex align-items-center justify-content-between  gap-2 mb-4 pb-2" style={{ borderBottom: `1px solid ${borderTheme}` }}>
                                <div className="d-flex">
                                    <Layers size={18} style={{ color: accentCol }} />
                                    <h6 style={{ margin: 0, fontWeight: "700", color: headingCol }} className="ps-2">Lot Inventory Allocation Workspace</h6>
                                </div>
                                <button
                                    onClick={handleShowAllocatedDetail}
                                    style={{
                                        background: "rgba(100, 116, 139, 0.15)",
                                        color: textTheme,
                                        border: `1px solid ${borderTheme}`,
                                        borderRadius: "10px",
                                        padding: "8px 16px",
                                        fontWeight: "600",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px"
                                    }}
                                    className="hover-scale-btn"
                                >
                                    <Info size={16} /> Show Details
                                </button>
                            </div>



                            {errors.lots && (
                                <div className="alert alert-danger py-2 mb-3" style={{ fontSize: "14px" }}>
                                    {errors.lots}
                                </div>
                            )}
                            <div style={{ display: "flex", alignItems: "stretch", gap: "8px", width: "100%" }}>
                                {/* 1. Available Lots (Left Panel) */}
                                <AvailableLotsPanel
                                    available={available}
                                    filteredAvailable={filteredAvailable}
                                    searchAvailable={searchAvailable}
                                    setSearchAvailable={setSearchAvailable}
                                    checkedAvailable={checkedAvailable}
                                    handleSelectAllAvailable={handleSelectAllAvailable}
                                    handleSelectAvailableRow={handleSelectAvailableRow}
                                    getCheckedRowBg={getCheckedRowBg}
                                    themeColors={themeColors}
                                    ISHelpModal={ISHelpModal}
                                />

                                {/* 2. Middle Transfer Buttons Controls */}
                                <div
                                    style={{
                                        width: "80px",
                                        flexShrink: 0,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    }}
                                >
                                    <div className="d-flex flex-md-column gap-3 align-items-center justify-content-center">

                                        {/* ALL BUTTON */}
                                        <button
                                            onClick={handleAllocateAll}
                                            disabled={isIssueMeterEditable}
                                            title="Allocate all checked available lots"
                                            className="trans-btn-all"
                                        >
                                            ALL
                                        </button>

                                        {/* RIGHT BUTTON */}
                                        <button
                                            onClick={moveSelectedRight}
                                            title="Allocate checked lots"
                                            className="trans-btn-right"
                                        >
                                            <ArrowRight size={22} />
                                        </button>


                                        {/*   BUTTON */}
                                        <button
                                            onClick={moveSelectedLeft}
                                            title="Return checked allocated lots"
                                            className="trans-btn-left"
                                        >
                                            <ArrowLeft size={22} />
                                        </button>

                                    </div>
                                </div>

                                {/* 3. Allocated Lots (Right Panel) */}

                                <AllocatedLotsPanel
                                    selected={selected}
                                    filteredSelected={filteredSelected}
                                    searchSelected={searchSelected}
                                    setSearchSelected={setSearchSelected}
                                    checkedSelected={checkedSelected}
                                    handleSelectAllSelected={handleSelectAllSelected}
                                    handleSelectSelectedRow={handleSelectSelectedRow}
                                    handleInlineSelectedEdit={handleInlineSelectedEdit}
                                    getCheckedRowBg={getCheckedRowBg}
                                    themeColors={themeColors}

                                />
                            </div>
                        </div>
                    )}

                    {/* D. RECORDS LIST (HISTORY LOG TABLE) */}
                    {!(isAdding || editingId) && (
                        <div
                            style={{
                                borderRadius: "14px",
                                overflow: "hidden",
                                border: `1px solid ${borderTheme}`,
                                boxShadow: "0 4px 15px rgba(0,0,0,0.15)"
                            }}
                        >
                            <div
                                style={{
                                    padding: "16px 20px",
                                    background: isdark === "light" ? iscolour?.Colour6 || "#cbd5e1" : iscolourDark?.Colour4 || "#14b8a6",
                                    color: "#fff",
                                    fontWeight: "700",
                                    letterSpacing: "0.5px"
                                }}
                                className="d-flex justify-content-between align-items-center"
                            >
                                <span>SAVED LOT ENTRY RECORDS LIST</span>
                                <span className="badge bg-white text-dark rounded-pill px-3 py-1 font-semibold" style={{ fontSize: "12px" }}>
                                    {filteredRecords.length} records found
                                </span>
                            </div>

                            <Millstagetablecruad
                                columns={tableColumns}
                                data={tableRows}
                                showActions={true}
                                onEdit={handleEdit}
                                onDelete={handleDelete}
                            />
                        </div>
                    )}
                </div>
            )}

            {/* CONFIRMATION ALLOCATION MODAL */}
            <AllocationModal
                show={isAllocationModalOpen}
                onHide={() => setIsAllocationModalOpen(false)}
                lotsToAllocate={lotsToAllocate}
                allocationErrors={allocationErrors}
                handleModalFieldEdit={handleModalFieldEdit}
                handleAllocateAsIs={handleAllocateAsIs}
                handleAllocateEdited={handleAllocateEdited}
                themeColors={themeColors}
                Details={Details}
            />

            {/* HELP / GUIDE MODAL */}
            <HelpModal
                show={isHelpModalOpen}
                onHide={() => setIsHelpModalOpen(false)}
                themeColors={themeColors}
            />

            {/* DELETE / UPDATE CONFIRMATION MODAL */}
            <Modal
                show={showConfirmModal}
                onHide={() => setShowConfirmModal(false)}
                centered
            >
                <Modal.Header
                    closeButton
                    style={{
                        background: bgCard,
                        color: textTheme,
                        borderBottom: `1px solid ${borderTheme}`
                    }}
                >
                    <Modal.Title style={{ fontSize: "18px", fontWeight: "700" }}>
                        Confirm Action
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body
                    style={{
                        background: bgCard,
                        color: textTheme
                    }}
                >
                    Are you sure you want to delete this Lot Entry transaction? This will return all allocated lots to the available pool.
                </Modal.Body>
                <Modal.Footer
                    style={{
                        background: bgCard,
                        borderTop: `1px solid ${borderTheme}`
                    }}
                >
                    <Button variant="secondary" onClick={() => setShowConfirmModal(false)}>
                        Cancel
                    </Button>
                    <Button
                        variant="danger"
                        onClick={executeDelete}
                    >
                        Yes, Delete Record
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* STOPPAGE DETAILS MODAL */}
            <StoppageModal
                show={isStoppageModalOpen}
                onHide={() => setIsStoppageModalOpen(false)}
                stoppageEntries={stoppageEntries}
                selectedStoppageRows={selectedStoppageRows}
                setSelectedStoppageRows={setSelectedStoppageRows}
                handleAddStoppageRow={handleAddStoppageRow}
                handleDeleteSelectedStoppages={handleDeleteSelectedStoppages}
                handleUpdateStoppageField={handleUpdateStoppageField}
                handleSaveStoppageDetails={handleSaveStoppageDetails}
                toMachineVal={toMachineVal}
                stoppageReasons={STOPPAGE_REASONS}
                themeColors={themeColors}
            />

            {/* RECIPE DETAIL MODAL */}
            <RecipeModal
                show={isRecipeModalOpen}
                onHide={() => setIsRecipeModalOpen(false)}
                themeColors={themeColors}
                treatmentDetails={treatmentDetails || []}
                recipeDetails={recipeDetails || []}
                TransFiltersdata={TransFiltersdata}
                AllFilterdata={AllFilterdata}
                selected={selected}
                weight={weight}
                setWeight={setWeight}
                liquorVal={liquorVal}
                setLiquorVal={setLiquorVal}
                calculateRecipeQty={calculateRecipeQty}
                onRecipeRowsChange={handleRecipeDetailRowsChange}
            />

            {/* TAKA DETAIL MODAL */}
            <TakaDetailModal
                TransFiltersdata={TransFiltersdata}
                show={isTakaDetailOpen}
                onHide={handleTakaDetailClose}
                onComplete={handleTakaDetailComplete}
                onIssueMeterEditableChange={setIsIssueMeterEditable}

                takaSearch={takaSearch}
                setTakaSearch={setTakaSearch}
                selectedTakas={selectedTakas}
                setSelectedTakas={setSelectedTakas}
                takaQty={takaQty}
                setTakaQty={setTakaQty}
                themeColors={themeColors}
                Details={Details}
                SubMianDetails={SubMianDetails}
                initialIssueMeterValues={initialIssueMeterValues}
                currentTransTypeId={gateTxnId}
                AppSetupDetaildata={AppSetupDetaildata}

                selectedIds={
                    selectedAvailableLot?.InwCode
                        ? [String(selectedAvailableLot.InwCode)]
                        : []


                }
            />

        </div>
    );

};

export default LotEntry;
